import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  JSONString: any;
  PositiveInt: any;
  RichText: any;
  UUID: any;
};

export type AnalyticsSettings = {
  __typename?: 'AnalyticsSettings';
  id?: Maybe<Scalars['ID']>;
  script?: Maybe<Scalars['String']>;
};

export type BlockQuoteBlock = StreamFieldInterface & {
  __typename?: 'BlockQuoteBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type BooleanBlock = StreamFieldInterface & {
  __typename?: 'BooleanBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['Boolean'];
};

export type CaptionedImageBlock = StreamFieldInterface & {
  __typename?: 'CaptionedImageBlock';
  blockType: Scalars['String'];
  blocks: Array<StreamFieldInterface>;
  caption?: Maybe<Scalars['RichText']>;
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  image?: Maybe<ImageObjectType>;
  rawValue: Scalars['String'];
};

export type CharBlock = StreamFieldInterface & {
  __typename?: 'CharBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type ChoiceBlock = StreamFieldInterface & {
  __typename?: 'ChoiceBlock';
  blockType: Scalars['String'];
  choices: Array<ChoiceOption>;
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type ChoiceOption = {
  __typename?: 'ChoiceOption';
  key: Scalars['String'];
  value: Scalars['String'];
};

/** Collection type */
export type CollectionObjectType = {
  __typename?: 'CollectionObjectType';
  ancestors: Array<Maybe<CollectionObjectType>>;
  depth: Scalars['Int'];
  descendants: Array<Maybe<CollectionObjectType>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  numchild: Scalars['Int'];
  path: Scalars['String'];
};

export type ContentPage = PageInterface & {
  __typename?: 'ContentPage';
  aliasOf?: Maybe<Page>;
  ancestors: Array<PageInterface>;
  body?: Maybe<Array<Maybe<StreamFieldInterface>>>;
  children: Array<PageInterface>;
  contentType: Scalars['String'];
  depth?: Maybe<Scalars['Int']>;
  descendants: Array<PageInterface>;
  draftTitle: Scalars['String'];
  expireAt?: Maybe<Scalars['DateTime']>;
  expired: Scalars['Boolean'];
  firstPublishedAt?: Maybe<Scalars['DateTime']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  hasUnpublishedChanges: Scalars['Boolean'];
  heroCaption?: Maybe<Scalars['String']>;
  heroImage?: Maybe<ImageObjectType>;
  id?: Maybe<Scalars['ID']>;
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  latestRevisionCreatedAt?: Maybe<Scalars['DateTime']>;
  live: Scalars['Boolean'];
  locked?: Maybe<Scalars['Boolean']>;
  lockedAt?: Maybe<Scalars['DateTime']>;
  nextSiblings: Array<PageInterface>;
  numchild: Scalars['Int'];
  pageType?: Maybe<Scalars['String']>;
  parent?: Maybe<PageInterface>;
  path: Scalars['String'];
  previousSiblings: Array<PageInterface>;
  searchDescription?: Maybe<Scalars['String']>;
  searchImage?: Maybe<ImageObjectType>;
  searchScore?: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<PageInterface>;
  slug: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  translationKey: Scalars['UUID'];
  url?: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


export type ContentPageAncestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type ContentPageChildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type ContentPageDescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type ContentPageNextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type ContentPagePreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type ContentPageSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type DateBlock = StreamFieldInterface & {
  __typename?: 'DateBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};


export type DateBlockValueArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type DateTimeBlock = StreamFieldInterface & {
  __typename?: 'DateTimeBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};


export type DateTimeBlockValueArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type DecimalBlock = StreamFieldInterface & {
  __typename?: 'DecimalBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['Float'];
};

export type DocumentChooserBlock = StreamFieldInterface & {
  __typename?: 'DocumentChooserBlock';
  blockType: Scalars['String'];
  document: DocumentObjectType;
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
};

/**
 * Base document type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type DocumentObjectType = {
  __typename?: 'DocumentObjectType';
  collection: CollectionObjectType;
  createdAt: Scalars['DateTime'];
  file: Scalars['String'];
  fileHash: Scalars['String'];
  fileSize?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  tags: Array<TagObjectType>;
  title: Scalars['String'];
  url: Scalars['String'];
};

export type DoubleListBlock = StreamFieldInterface & {
  __typename?: 'DoubleListBlock';
  blockType: Scalars['String'];
  blocks: Array<StreamFieldInterface>;
  columnOne?: Maybe<Array<Maybe<StreamFieldInterface>>>;
  columnTwo?: Maybe<Array<Maybe<StreamFieldInterface>>>;
  field: Scalars['String'];
  heading?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
};

export type EmailBlock = StreamFieldInterface & {
  __typename?: 'EmailBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type EmbedBlock = StreamFieldInterface & {
  __typename?: 'EmbedBlock';
  blockType: Scalars['String'];
  embed?: Maybe<Scalars['String']>;
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawEmbed?: Maybe<Scalars['JSONString']>;
  rawValue: Scalars['String'];
  url: Scalars['String'];
  value: Scalars['String'];
};

export type ExternalLinkBlock = StreamFieldInterface & {
  __typename?: 'ExternalLinkBlock';
  blockType: Scalars['String'];
  blocks: Array<StreamFieldInterface>;
  field: Scalars['String'];
  href: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  text: Scalars['String'];
};

export type FeaturedContentBlock = StreamFieldInterface & {
  __typename?: 'FeaturedContentBlock';
  blockType: Scalars['String'];
  blocks: Array<StreamFieldInterface>;
  content: Scalars['String'];
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  image?: Maybe<ImageObjectType>;
  link?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type FeaturedNews = {
  __typename?: 'FeaturedNews';
  id?: Maybe<Scalars['ID']>;
  news?: Maybe<PageInterface>;
};

export type FeaturedProject = {
  __typename?: 'FeaturedProject';
  id?: Maybe<Scalars['ID']>;
  project?: Maybe<PageInterface>;
};

export type FloatBlock = StreamFieldInterface & {
  __typename?: 'FloatBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['Float'];
};

export type FooterSettings = {
  __typename?: 'FooterSettings';
  ctaEmail?: Maybe<Scalars['String']>;
  ctaText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  links?: Maybe<Array<Maybe<StreamFieldInterface>>>;
};

export type HomePage = PageInterface & {
  __typename?: 'HomePage';
  aliasOf?: Maybe<Page>;
  ancestors: Array<PageInterface>;
  children: Array<PageInterface>;
  contentType: Scalars['String'];
  ctaLink?: Maybe<PageInterface>;
  ctaText?: Maybe<Scalars['String']>;
  depth?: Maybe<Scalars['Int']>;
  descendants: Array<PageInterface>;
  draftTitle: Scalars['String'];
  expireAt?: Maybe<Scalars['DateTime']>;
  expired: Scalars['Boolean'];
  explainer?: Maybe<Scalars['String']>;
  featuredNews?: Maybe<Array<Maybe<FeaturedNews>>>;
  featuredProjects?: Maybe<Array<Maybe<FeaturedProject>>>;
  firstPublishedAt?: Maybe<Scalars['DateTime']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  hasUnpublishedChanges: Scalars['Boolean'];
  heroImage?: Maybe<ImageObjectType>;
  id?: Maybe<Scalars['ID']>;
  introText?: Maybe<Scalars['String']>;
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  latestRevisionCreatedAt?: Maybe<Scalars['DateTime']>;
  live: Scalars['Boolean'];
  locked?: Maybe<Scalars['Boolean']>;
  lockedAt?: Maybe<Scalars['DateTime']>;
  newsListing?: Maybe<PageInterface>;
  nextSiblings: Array<PageInterface>;
  numchild: Scalars['Int'];
  pageType?: Maybe<Scalars['String']>;
  parent?: Maybe<PageInterface>;
  path: Scalars['String'];
  previousSiblings: Array<PageInterface>;
  projectListing?: Maybe<PageInterface>;
  searchDescription?: Maybe<Scalars['String']>;
  searchImage?: Maybe<ImageObjectType>;
  searchScore?: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<PageInterface>;
  slug: Scalars['String'];
  subrands?: Maybe<Array<Maybe<Subrand>>>;
  tagline?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  translationKey: Scalars['UUID'];
  url?: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


export type HomePageAncestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type HomePageChildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type HomePageDescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type HomePageFeaturedNewsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type HomePageFeaturedProjectsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type HomePageNextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type HomePagePreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type HomePageSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type HomePageSubrandsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type ImageChooserBlock = StreamFieldInterface & {
  __typename?: 'ImageChooserBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  image: ImageObjectType;
  rawValue: Scalars['String'];
};

export type ImageObjectType = {
  __typename?: 'ImageObjectType';
  aspectRatio: Scalars['Float'];
  collection: CollectionObjectType;
  createdAt: Scalars['DateTime'];
  file: Scalars['String'];
  fileHash: Scalars['String'];
  fileSize?: Maybe<Scalars['Int']>;
  focalPointHeight?: Maybe<Scalars['Int']>;
  focalPointWidth?: Maybe<Scalars['Int']>;
  focalPointX?: Maybe<Scalars['Int']>;
  focalPointY?: Maybe<Scalars['Int']>;
  height: Scalars['Int'];
  id: Scalars['ID'];
  isSvg: Scalars['Boolean'];
  rendition?: Maybe<ImageRenditionObjectType>;
  renditions: Array<ImageRenditionObjectType>;
  sizes: Scalars['String'];
  /** @deprecated Use the `url` attribute */
  src: Scalars['String'];
  srcSet?: Maybe<Scalars['String']>;
  tags: Array<TagObjectType>;
  title: Scalars['String'];
  url: Scalars['String'];
  width: Scalars['Int'];
};


export type ImageObjectTypeRenditionArgs = {
  bgcolor?: InputMaybe<Scalars['String']>;
  fill?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  jpegquality?: InputMaybe<Scalars['Int']>;
  max?: InputMaybe<Scalars['String']>;
  min?: InputMaybe<Scalars['String']>;
  preserveSvg?: InputMaybe<Scalars['Boolean']>;
  webpquality?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};


export type ImageObjectTypeSrcSetArgs = {
  format?: InputMaybe<Scalars['String']>;
  preserveSvg?: InputMaybe<Scalars['Boolean']>;
  sizes?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type ImageRenditionObjectType = {
  __typename?: 'ImageRenditionObjectType';
  alt: Scalars['String'];
  backgroundPositionStyle: Scalars['String'];
  file: Scalars['String'];
  filterSpec: Scalars['String'];
  focalPoint?: Maybe<Scalars['String']>;
  focalPointKey: Scalars['String'];
  height: Scalars['Int'];
  id: Scalars['ID'];
  image: ImageObjectType;
  url: Scalars['String'];
  width: Scalars['Int'];
};

export type IntegerBlock = StreamFieldInterface & {
  __typename?: 'IntegerBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['Int'];
};

export type InternalLinkBlock = StreamFieldInterface & {
  __typename?: 'InternalLinkBlock';
  blockType: Scalars['String'];
  blocks: Array<StreamFieldInterface>;
  field: Scalars['String'];
  href: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  text: Scalars['String'];
};

export type ListBlock = StreamFieldInterface & {
  __typename?: 'ListBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  items: Array<StreamFieldInterface>;
  rawValue: Scalars['String'];
};

export type ListItem = StreamFieldInterface & {
  __typename?: 'ListItem';
  blockType: Scalars['String'];
  blocks: Array<StreamFieldInterface>;
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  indentationLevel: Scalars['Int'];
  rawValue: Scalars['String'];
  text: Scalars['String'];
};

export type LocationTag = {
  __typename?: 'LocationTag';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type LocationTaggedPerson = {
  __typename?: 'LocationTaggedPerson';
  id?: Maybe<Scalars['ID']>;
};

export type MenuSettings = {
  __typename?: 'MenuSettings';
  id?: Maybe<Scalars['ID']>;
  menu?: Maybe<Array<Maybe<StreamFieldInterface>>>;
  subrandLinks?: Maybe<Array<Maybe<StreamFieldInterface>>>;
};

export type NewsIndex = PageInterface & {
  __typename?: 'NewsIndex';
  aliasOf?: Maybe<Page>;
  ancestors: Array<PageInterface>;
  children: Array<PageInterface>;
  contentType: Scalars['String'];
  depth?: Maybe<Scalars['Int']>;
  descendants: Array<PageInterface>;
  draftTitle: Scalars['String'];
  expireAt?: Maybe<Scalars['DateTime']>;
  expired: Scalars['Boolean'];
  firstPublishedAt?: Maybe<Scalars['DateTime']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  hasUnpublishedChanges: Scalars['Boolean'];
  id?: Maybe<Scalars['ID']>;
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  latestRevisionCreatedAt?: Maybe<Scalars['DateTime']>;
  live: Scalars['Boolean'];
  locked?: Maybe<Scalars['Boolean']>;
  lockedAt?: Maybe<Scalars['DateTime']>;
  nextSiblings: Array<PageInterface>;
  numchild: Scalars['Int'];
  pageType?: Maybe<Scalars['String']>;
  parent?: Maybe<PageInterface>;
  path: Scalars['String'];
  previousSiblings: Array<PageInterface>;
  searchDescription?: Maybe<Scalars['String']>;
  searchImage?: Maybe<ImageObjectType>;
  searchScore?: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<PageInterface>;
  slug: Scalars['String'];
  tags?: Maybe<Array<Maybe<NewsTag>>>;
  title: Scalars['String'];
  translationKey: Scalars['UUID'];
  url?: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


export type NewsIndexAncestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type NewsIndexChildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type NewsIndexDescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type NewsIndexNextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type NewsIndexPreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type NewsIndexSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type NewsIndexTagsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type NewsPage = PageInterface & {
  __typename?: 'NewsPage';
  aliasOf?: Maybe<Page>;
  ancestors: Array<PageInterface>;
  body?: Maybe<Array<Maybe<StreamFieldInterface>>>;
  children: Array<PageInterface>;
  contentType: Scalars['String'];
  depth?: Maybe<Scalars['Int']>;
  descendants: Array<PageInterface>;
  draftTitle: Scalars['String'];
  expireAt?: Maybe<Scalars['DateTime']>;
  expired: Scalars['Boolean'];
  firstPublishedAt?: Maybe<Scalars['DateTime']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  hasUnpublishedChanges: Scalars['Boolean'];
  heroCaption?: Maybe<Scalars['String']>;
  heroImage?: Maybe<ImageObjectType>;
  id?: Maybe<Scalars['ID']>;
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  latestRevisionCreatedAt?: Maybe<Scalars['DateTime']>;
  live: Scalars['Boolean'];
  locked?: Maybe<Scalars['Boolean']>;
  lockedAt?: Maybe<Scalars['DateTime']>;
  nextSiblings: Array<PageInterface>;
  numchild: Scalars['Int'];
  pageType?: Maybe<Scalars['String']>;
  parent?: Maybe<PageInterface>;
  path: Scalars['String'];
  previousSiblings: Array<PageInterface>;
  searchDescription?: Maybe<Scalars['String']>;
  searchImage?: Maybe<ImageObjectType>;
  searchScore?: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<PageInterface>;
  slug: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<NewsTag>>>;
  title: Scalars['String'];
  translationKey: Scalars['UUID'];
  url?: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


export type NewsPageAncestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type NewsPageChildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type NewsPageDescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type NewsPageNextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type NewsPagePreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type NewsPageSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type NewsPageTagsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type NewsPagePaginatedType = {
  __typename?: 'NewsPagePaginatedType';
  items?: Maybe<Array<Maybe<NewsPage>>>;
  pagination?: Maybe<PaginationType>;
};

export type NewsTag = {
  __typename?: 'NewsTag';
  id?: Maybe<Scalars['ID']>;
  isTagged?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type NewsTaggedItem = {
  __typename?: 'NewsTaggedItem';
  id?: Maybe<Scalars['ID']>;
};

/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type Page = PageInterface & {
  __typename?: 'Page';
  aliasOf?: Maybe<Page>;
  aliases: Array<Page>;
  ancestors: Array<PageInterface>;
  children: Array<PageInterface>;
  contentType: Scalars['String'];
  contentpage?: Maybe<ContentPage>;
  depth?: Maybe<Scalars['Int']>;
  descendants: Array<PageInterface>;
  draftTitle: Scalars['String'];
  expireAt?: Maybe<Scalars['DateTime']>;
  expired: Scalars['Boolean'];
  firstPublishedAt?: Maybe<Scalars['DateTime']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  hasUnpublishedChanges: Scalars['Boolean'];
  homepage?: Maybe<HomePage>;
  id?: Maybe<Scalars['ID']>;
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  latestRevisionCreatedAt?: Maybe<Scalars['DateTime']>;
  live: Scalars['Boolean'];
  locked?: Maybe<Scalars['Boolean']>;
  lockedAt?: Maybe<Scalars['DateTime']>;
  newsindex?: Maybe<NewsIndex>;
  newspage?: Maybe<NewsPage>;
  nextSiblings: Array<PageInterface>;
  numchild: Scalars['Int'];
  pageType?: Maybe<Scalars['String']>;
  parent?: Maybe<PageInterface>;
  path: Scalars['String'];
  previousSiblings: Array<PageInterface>;
  projectlistingpage?: Maybe<ProjectListingPage>;
  projectpage?: Maybe<ProjectPage>;
  searchDescription?: Maybe<Scalars['String']>;
  searchScore?: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<PageInterface>;
  sitesRootedHere: Array<SiteObjectType>;
  slug: Scalars['String'];
  teampage?: Maybe<TeamPage>;
  title: Scalars['String'];
  translationKey: Scalars['UUID'];
  url?: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type PageAncestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type PageChildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type PageDescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type PageNextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type PagePreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type PageSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type PageChooserBlock = StreamFieldInterface & {
  __typename?: 'PageChooserBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  page: PageInterface;
  rawValue: Scalars['String'];
};

export type PageInterface = {
  ancestors: Array<PageInterface>;
  children: Array<PageInterface>;
  contentType: Scalars['String'];
  depth?: Maybe<Scalars['Int']>;
  descendants: Array<PageInterface>;
  firstPublishedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  live: Scalars['Boolean'];
  locked?: Maybe<Scalars['Boolean']>;
  nextSiblings: Array<PageInterface>;
  pageType?: Maybe<Scalars['String']>;
  parent?: Maybe<PageInterface>;
  previousSiblings: Array<PageInterface>;
  searchDescription?: Maybe<Scalars['String']>;
  searchScore?: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<PageInterface>;
  slug: Scalars['String'];
  title: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


export type PageInterfaceAncestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type PageInterfaceChildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type PageInterfaceDescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type PageInterfaceNextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type PageInterfacePreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type PageInterfaceSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

/** GraphQL type for Paginated QuerySet pagination field. */
export type PaginationType = {
  __typename?: 'PaginationType';
  count: Scalars['PositiveInt'];
  currentPage: Scalars['PositiveInt'];
  nextPage?: Maybe<Scalars['PositiveInt']>;
  perPage: Scalars['PositiveInt'];
  prevPage?: Maybe<Scalars['PositiveInt']>;
  total: Scalars['PositiveInt'];
  totalPages: Scalars['PositiveInt'];
};

export type Person = {
  __typename?: 'Person';
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<ImageObjectType>;
  linkedin?: Maybe<Scalars['String']>;
  location?: Maybe<Array<Maybe<LocationTag>>>;
  name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};


export type PersonLocationArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type PersonPaginatedType = {
  __typename?: 'PersonPaginatedType';
  items?: Maybe<Array<Maybe<Person>>>;
  pagination?: Maybe<PaginationType>;
};

export type ProjectListingPage = PageInterface & {
  __typename?: 'ProjectListingPage';
  aliasOf?: Maybe<Page>;
  ancestors: Array<PageInterface>;
  children: Array<PageInterface>;
  contentType: Scalars['String'];
  depth?: Maybe<Scalars['Int']>;
  descendants: Array<PageInterface>;
  draftTitle: Scalars['String'];
  expireAt?: Maybe<Scalars['DateTime']>;
  expired: Scalars['Boolean'];
  firstPublishedAt?: Maybe<Scalars['DateTime']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  hasUnpublishedChanges: Scalars['Boolean'];
  id?: Maybe<Scalars['ID']>;
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  latestRevisionCreatedAt?: Maybe<Scalars['DateTime']>;
  live: Scalars['Boolean'];
  locked?: Maybe<Scalars['Boolean']>;
  lockedAt?: Maybe<Scalars['DateTime']>;
  nextSiblings: Array<PageInterface>;
  numchild: Scalars['Int'];
  pageType?: Maybe<Scalars['String']>;
  parent?: Maybe<PageInterface>;
  path: Scalars['String'];
  previousSiblings: Array<PageInterface>;
  searchDescription?: Maybe<Scalars['String']>;
  searchImage?: Maybe<ImageObjectType>;
  searchScore?: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<PageInterface>;
  slug: Scalars['String'];
  title: Scalars['String'];
  translationKey: Scalars['UUID'];
  url?: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


export type ProjectListingPageAncestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type ProjectListingPageChildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type ProjectListingPageDescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type ProjectListingPageNextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type ProjectListingPagePreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type ProjectListingPageSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type ProjectPage = PageInterface & {
  __typename?: 'ProjectPage';
  aliasOf?: Maybe<Page>;
  ancestors: Array<PageInterface>;
  body?: Maybe<Array<Maybe<StreamFieldInterface>>>;
  children: Array<PageInterface>;
  contentType: Scalars['String'];
  depth?: Maybe<Scalars['Int']>;
  descendants: Array<PageInterface>;
  description?: Maybe<Scalars['String']>;
  draftTitle: Scalars['String'];
  expireAt?: Maybe<Scalars['DateTime']>;
  expired: Scalars['Boolean'];
  firstPublishedAt?: Maybe<Scalars['DateTime']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  hasUnpublishedChanges: Scalars['Boolean'];
  heroCaption?: Maybe<Scalars['String']>;
  heroImage?: Maybe<ImageObjectType>;
  id?: Maybe<Scalars['ID']>;
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  latestRevisionCreatedAt?: Maybe<Scalars['DateTime']>;
  live: Scalars['Boolean'];
  locked?: Maybe<Scalars['Boolean']>;
  lockedAt?: Maybe<Scalars['DateTime']>;
  nextSiblings: Array<PageInterface>;
  numchild: Scalars['Int'];
  pageType?: Maybe<Scalars['String']>;
  parent?: Maybe<PageInterface>;
  path: Scalars['String'];
  previousSiblings: Array<PageInterface>;
  searchDescription?: Maybe<Scalars['String']>;
  searchImage?: Maybe<ImageObjectType>;
  searchScore?: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<PageInterface>;
  slug: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  translationKey: Scalars['UUID'];
  url?: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


export type ProjectPageAncestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type ProjectPageChildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type ProjectPageDescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type ProjectPageNextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type ProjectPagePreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type ProjectPageSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type ProjectPagePaginatedType = {
  __typename?: 'ProjectPagePaginatedType';
  items?: Maybe<Array<Maybe<ProjectPage>>>;
  pagination?: Maybe<PaginationType>;
};

export type Query = {
  __typename?: 'Query';
  analyticsSettings?: Maybe<AnalyticsSettings>;
  collections: Array<Maybe<CollectionObjectType>>;
  document?: Maybe<DocumentObjectType>;
  documentType: Scalars['String'];
  documents: Array<DocumentObjectType>;
  footerSettings?: Maybe<FooterSettings>;
  home: HomePage;
  image?: Maybe<ImageObjectType>;
  imageType: Scalars['String'];
  images: Array<ImageObjectType>;
  menuSettings?: Maybe<MenuSettings>;
  newsIndex?: Maybe<NewsIndex>;
  newsIndexs?: Maybe<Array<Maybe<NewsIndex>>>;
  newsPage?: Maybe<NewsPage>;
  newsPages?: Maybe<NewsPagePaginatedType>;
  newsTag?: Maybe<NewsTag>;
  newsTags?: Maybe<Array<Maybe<NewsTag>>>;
  page?: Maybe<PageInterface>;
  pages: Array<PageInterface>;
  people?: Maybe<PersonPaginatedType>;
  peopleLocation?: Maybe<LocationTag>;
  peopleLocations?: Maybe<Array<Maybe<LocationTag>>>;
  person?: Maybe<Person>;
  projectPage?: Maybe<ProjectPage>;
  projectPages?: Maybe<ProjectPagePaginatedType>;
  redirects: Array<Redirect>;
  search: Array<Search>;
  setting?: Maybe<SettingsObjectType>;
  settings: Array<SettingsObjectType>;
  site?: Maybe<SiteObjectType>;
  sites: Array<SiteObjectType>;
  tag?: Maybe<TagObjectType>;
  tags: Array<TagObjectType>;
};


export type QueryAnalyticsSettingsArgs = {
  order?: InputMaybe<Scalars['String']>;
};


export type QueryCollectionsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
};


export type QueryDocumentArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryDocumentsArgs = {
  collection?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type QueryFooterSettingsArgs = {
  order?: InputMaybe<Scalars['String']>;
};


export type QueryHomeArgs = {
  order?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};


export type QueryImageArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryImagesArgs = {
  collection?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type QueryMenuSettingsArgs = {
  order?: InputMaybe<Scalars['String']>;
};


export type QueryNewsIndexArgs = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  urlPath?: InputMaybe<Scalars['String']>;
};


export type QueryNewsIndexsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type QueryNewsPageArgs = {
  id?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  urlPath?: InputMaybe<Scalars['String']>;
};


export type QueryNewsPagesArgs = {
  id?: InputMaybe<Scalars['ID']>;
  order?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['PositiveInt']>;
  perPage?: InputMaybe<Scalars['PositiveInt']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['String']>;
};


export type QueryNewsTagArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryNewsTagsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type QueryPageArgs = {
  contentType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  inSite?: InputMaybe<Scalars['Boolean']>;
  site?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  urlPath?: InputMaybe<Scalars['String']>;
};


export type QueryPagesArgs = {
  ancestor?: InputMaybe<Scalars['ID']>;
  contentType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  inSite?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<Scalars['ID']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Scalars['String']>;
};


export type QueryPeopleArgs = {
  id?: InputMaybe<Scalars['ID']>;
  order?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['PositiveInt']>;
  perPage?: InputMaybe<Scalars['PositiveInt']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['String']>;
};


export type QueryPeopleLocationArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryPeopleLocationsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type QueryPersonArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryProjectPageArgs = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  urlPath?: InputMaybe<Scalars['String']>;
};


export type QueryProjectPagesArgs = {
  id?: InputMaybe<Scalars['ID']>;
  order?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['PositiveInt']>;
  perPage?: InputMaybe<Scalars['PositiveInt']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type QuerySearchArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QuerySettingArgs = {
  name?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Scalars['String']>;
};


export type QuerySettingsArgs = {
  name?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Scalars['String']>;
};


export type QuerySiteArgs = {
  hostname?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QuerySitesArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type QueryTagArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryTagsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
};

export type QuoteBlock = StreamFieldInterface & {
  __typename?: 'QuoteBlock';
  attribution?: Maybe<Scalars['String']>;
  blockType: Scalars['String'];
  blocks: Array<StreamFieldInterface>;
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  quote: Scalars['String'];
  rawValue: Scalars['String'];
};

export type RawHtmlBlock = StreamFieldInterface & {
  __typename?: 'RawHTMLBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type Redirect = {
  __typename?: 'Redirect';
  isPermanent: Scalars['Boolean'];
  newUrl?: Maybe<Scalars['String']>;
  oldPath: Scalars['String'];
  oldUrl: Scalars['String'];
  page?: Maybe<PageInterface>;
  site: SiteObjectType;
};

export type RegexBlock = StreamFieldInterface & {
  __typename?: 'RegexBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type RichTextBlock = StreamFieldInterface & {
  __typename?: 'RichTextBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type Search = AnalyticsSettings | ContentPage | FeaturedNews | FeaturedProject | FooterSettings | HomePage | LocationTag | LocationTaggedPerson | MenuSettings | NewsIndex | NewsPage | NewsTag | NewsTaggedItem | Page | Person | ProjectListingPage | ProjectPage | Subrand | SubrandProduct | TeamPage;

export type SettingsObjectType = AnalyticsSettings | FooterSettings | MenuSettings;

export type SiteObjectType = {
  __typename?: 'SiteObjectType';
  analyticssettings?: Maybe<AnalyticsSettings>;
  footersettings?: Maybe<FooterSettings>;
  hostname: Scalars['String'];
  id: Scalars['ID'];
  /** If true, this site will handle requests for all other hostnames that do not have a site entry of their own */
  isDefaultSite: Scalars['Boolean'];
  menusettings?: Maybe<MenuSettings>;
  page?: Maybe<PageInterface>;
  pages: Array<PageInterface>;
  /** Set this to something other than 80 if you need a specific port number to appear in URLs (e.g. development on port 8000). Does not affect request handling (so port forwarding still works). */
  port: Scalars['Int'];
  rootPage: Page;
  /** Human-readable name for the site. */
  siteName: Scalars['String'];
};


export type SiteObjectTypePageArgs = {
  contentType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  urlPath?: InputMaybe<Scalars['String']>;
};


export type SiteObjectTypePagesArgs = {
  contentType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type StaticBlock = StreamFieldInterface & {
  __typename?: 'StaticBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type StreamBlock = StreamFieldInterface & {
  __typename?: 'StreamBlock';
  blockType: Scalars['String'];
  blocks: Array<StreamFieldInterface>;
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
};

export type StreamFieldBlock = StreamFieldInterface & {
  __typename?: 'StreamFieldBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type StreamFieldInterface = {
  blockType: Scalars['String'];
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
};

export type StructBlock = StreamFieldInterface & {
  __typename?: 'StructBlock';
  blockType: Scalars['String'];
  blocks: Array<StreamFieldInterface>;
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
};

export type SubMenuBlock = StreamFieldInterface & {
  __typename?: 'SubMenuBlock';
  blockType: Scalars['String'];
  blocks: Array<StreamFieldInterface>;
  field: Scalars['String'];
  href: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<StreamFieldInterface>>>;
  rawValue: Scalars['String'];
  text: Scalars['String'];
};

export type Subrand = {
  __typename?: 'Subrand';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<ImageObjectType>;
  link?: Maybe<PageInterface>;
  name?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Maybe<SubrandProduct>>>;
};


export type SubrandProductsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type SubrandProduct = {
  __typename?: 'SubrandProduct';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  page?: Maybe<PageInterface>;
};

export type TagObjectType = {
  __typename?: 'TagObjectType';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type TeamPage = PageInterface & {
  __typename?: 'TeamPage';
  aliasOf?: Maybe<Page>;
  ancestors: Array<PageInterface>;
  children: Array<PageInterface>;
  contentType: Scalars['String'];
  depth?: Maybe<Scalars['Int']>;
  descendants: Array<PageInterface>;
  draftTitle: Scalars['String'];
  expireAt?: Maybe<Scalars['DateTime']>;
  expired: Scalars['Boolean'];
  firstPublishedAt?: Maybe<Scalars['DateTime']>;
  goLiveAt?: Maybe<Scalars['DateTime']>;
  hasUnpublishedChanges: Scalars['Boolean'];
  id?: Maybe<Scalars['ID']>;
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  latestRevisionCreatedAt?: Maybe<Scalars['DateTime']>;
  live: Scalars['Boolean'];
  locked?: Maybe<Scalars['Boolean']>;
  lockedAt?: Maybe<Scalars['DateTime']>;
  nextSiblings: Array<PageInterface>;
  numchild: Scalars['Int'];
  pageType?: Maybe<Scalars['String']>;
  parent?: Maybe<PageInterface>;
  path: Scalars['String'];
  people?: Maybe<Array<Maybe<Person>>>;
  previousSiblings: Array<PageInterface>;
  searchDescription?: Maybe<Scalars['String']>;
  searchImage?: Maybe<ImageObjectType>;
  searchScore?: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<PageInterface>;
  slug: Scalars['String'];
  title: Scalars['String'];
  translationKey: Scalars['UUID'];
  url?: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


export type TeamPageAncestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type TeamPageChildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type TeamPageDescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type TeamPageNextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type TeamPagePeopleArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type TeamPagePreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type TeamPageSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['PositiveInt']>;
  offset?: InputMaybe<Scalars['PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type TextBlock = StreamFieldInterface & {
  __typename?: 'TextBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type TimeBlock = StreamFieldInterface & {
  __typename?: 'TimeBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};


export type TimeBlockValueArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type UrlBlock = StreamFieldInterface & {
  __typename?: 'URLBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type PageQueryVariables = Exact<{
  urlPath: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
}>;


export type PageQuery = { __typename?: 'Query', page?: { __typename?: 'ContentPage', title: string, slug: string, urlPath: string, pageType?: string | null, seoTitle: string, searchDescription?: string | null, subtitle?: string | null, heroCaption?: string | null, searchImage?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null, heroImage?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null, body?: Array<{ __typename?: 'BlockQuoteBlock', blockType: string } | { __typename?: 'BooleanBlock', blockType: string } | { __typename?: 'CaptionedImageBlock', blockType: string, caption?: any | null, image?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null } | { __typename?: 'CharBlock', blockType: string } | { __typename?: 'ChoiceBlock', blockType: string } | { __typename?: 'DateBlock', blockType: string } | { __typename?: 'DateTimeBlock', blockType: string } | { __typename?: 'DecimalBlock', blockType: string } | { __typename?: 'DocumentChooserBlock', blockType: string } | { __typename?: 'DoubleListBlock', blockType: string, heading?: string | null, columnOne?: Array<{ __typename?: 'BlockQuoteBlock' } | { __typename?: 'BooleanBlock' } | { __typename?: 'CaptionedImageBlock' } | { __typename?: 'CharBlock' } | { __typename?: 'ChoiceBlock' } | { __typename?: 'DateBlock' } | { __typename?: 'DateTimeBlock' } | { __typename?: 'DecimalBlock' } | { __typename?: 'DocumentChooserBlock' } | { __typename?: 'DoubleListBlock' } | { __typename?: 'EmailBlock' } | { __typename?: 'EmbedBlock' } | { __typename?: 'ExternalLinkBlock' } | { __typename?: 'FeaturedContentBlock' } | { __typename?: 'FloatBlock' } | { __typename?: 'ImageChooserBlock' } | { __typename?: 'IntegerBlock' } | { __typename?: 'InternalLinkBlock' } | { __typename?: 'ListBlock' } | { __typename?: 'ListItem', indentationLevel: number, text: string } | { __typename?: 'PageChooserBlock' } | { __typename?: 'QuoteBlock' } | { __typename?: 'RawHTMLBlock' } | { __typename?: 'RegexBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'StaticBlock' } | { __typename?: 'StreamBlock' } | { __typename?: 'StreamFieldBlock' } | { __typename?: 'StructBlock' } | { __typename?: 'SubMenuBlock' } | { __typename?: 'TextBlock' } | { __typename?: 'TimeBlock' } | { __typename?: 'URLBlock' } | null> | null, columnTwo?: Array<{ __typename?: 'BlockQuoteBlock' } | { __typename?: 'BooleanBlock' } | { __typename?: 'CaptionedImageBlock' } | { __typename?: 'CharBlock' } | { __typename?: 'ChoiceBlock' } | { __typename?: 'DateBlock' } | { __typename?: 'DateTimeBlock' } | { __typename?: 'DecimalBlock' } | { __typename?: 'DocumentChooserBlock' } | { __typename?: 'DoubleListBlock' } | { __typename?: 'EmailBlock' } | { __typename?: 'EmbedBlock' } | { __typename?: 'ExternalLinkBlock' } | { __typename?: 'FeaturedContentBlock' } | { __typename?: 'FloatBlock' } | { __typename?: 'ImageChooserBlock' } | { __typename?: 'IntegerBlock' } | { __typename?: 'InternalLinkBlock' } | { __typename?: 'ListBlock' } | { __typename?: 'ListItem', indentationLevel: number, text: string } | { __typename?: 'PageChooserBlock' } | { __typename?: 'QuoteBlock' } | { __typename?: 'RawHTMLBlock' } | { __typename?: 'RegexBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'StaticBlock' } | { __typename?: 'StreamBlock' } | { __typename?: 'StreamFieldBlock' } | { __typename?: 'StructBlock' } | { __typename?: 'SubMenuBlock' } | { __typename?: 'TextBlock' } | { __typename?: 'TimeBlock' } | { __typename?: 'URLBlock' } | null> | null } | { __typename?: 'EmailBlock', blockType: string } | { __typename?: 'EmbedBlock', blockType: string, embed?: string | null } | { __typename?: 'ExternalLinkBlock', blockType: string } | { __typename?: 'FeaturedContentBlock', blockType: string, title?: string | null, content: string, link?: string | null, linkText?: string | null, image?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null } | { __typename?: 'FloatBlock', blockType: string } | { __typename?: 'ImageChooserBlock', blockType: string } | { __typename?: 'IntegerBlock', blockType: string } | { __typename?: 'InternalLinkBlock', blockType: string } | { __typename?: 'ListBlock', blockType: string } | { __typename?: 'ListItem', blockType: string } | { __typename?: 'PageChooserBlock', blockType: string } | { __typename?: 'QuoteBlock', blockType: string, field: string, blocks: Array<{ __typename?: 'BlockQuoteBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'BooleanBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'CaptionedImageBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'CharBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ChoiceBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DateBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DateTimeBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DecimalBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DocumentChooserBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DoubleListBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'EmailBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'EmbedBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ExternalLinkBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'FeaturedContentBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'FloatBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ImageChooserBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'IntegerBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'InternalLinkBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ListBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ListItem', blockType: string, field: string, rawValue: string } | { __typename?: 'PageChooserBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'QuoteBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'RawHTMLBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'RegexBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'RichTextBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StaticBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StreamBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StreamFieldBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StructBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'SubMenuBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'TextBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'TimeBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'URLBlock', blockType: string, field: string, rawValue: string }> } | { __typename?: 'RawHTMLBlock', blockType: string } | { __typename?: 'RegexBlock', blockType: string } | { __typename?: 'RichTextBlock', blockType: string, id?: string | null, value: string } | { __typename?: 'StaticBlock', blockType: string } | { __typename?: 'StreamBlock', blockType: string } | { __typename?: 'StreamFieldBlock', blockType: string } | { __typename?: 'StructBlock', blockType: string } | { __typename?: 'SubMenuBlock', blockType: string } | { __typename?: 'TextBlock', blockType: string } | { __typename?: 'TimeBlock', blockType: string } | { __typename?: 'URLBlock', blockType: string } | null> | null } | { __typename?: 'HomePage', title: string, slug: string, urlPath: string, pageType?: string | null, seoTitle: string, searchDescription?: string | null } | { __typename?: 'NewsIndex', title: string, slug: string, urlPath: string, pageType?: string | null, seoTitle: string, searchDescription?: string | null, searchImage?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null, tags?: Array<{ __typename?: 'NewsTag', name?: string | null, slug?: string | null, isTagged?: boolean | null } | null> | null } | { __typename?: 'NewsPage', title: string, slug: string, urlPath: string, pageType?: string | null, seoTitle: string, searchDescription?: string | null, subtitle?: string | null, heroCaption?: string | null, searchImage?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null, heroImage?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null, body?: Array<{ __typename?: 'BlockQuoteBlock', blockType: string } | { __typename?: 'BooleanBlock', blockType: string } | { __typename?: 'CaptionedImageBlock', blockType: string, caption?: any | null, image?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null } | { __typename?: 'CharBlock', blockType: string } | { __typename?: 'ChoiceBlock', blockType: string } | { __typename?: 'DateBlock', blockType: string } | { __typename?: 'DateTimeBlock', blockType: string } | { __typename?: 'DecimalBlock', blockType: string } | { __typename?: 'DocumentChooserBlock', blockType: string } | { __typename?: 'DoubleListBlock', blockType: string, heading?: string | null, columnOne?: Array<{ __typename?: 'BlockQuoteBlock' } | { __typename?: 'BooleanBlock' } | { __typename?: 'CaptionedImageBlock' } | { __typename?: 'CharBlock' } | { __typename?: 'ChoiceBlock' } | { __typename?: 'DateBlock' } | { __typename?: 'DateTimeBlock' } | { __typename?: 'DecimalBlock' } | { __typename?: 'DocumentChooserBlock' } | { __typename?: 'DoubleListBlock' } | { __typename?: 'EmailBlock' } | { __typename?: 'EmbedBlock' } | { __typename?: 'ExternalLinkBlock' } | { __typename?: 'FeaturedContentBlock' } | { __typename?: 'FloatBlock' } | { __typename?: 'ImageChooserBlock' } | { __typename?: 'IntegerBlock' } | { __typename?: 'InternalLinkBlock' } | { __typename?: 'ListBlock' } | { __typename?: 'ListItem', indentationLevel: number, text: string } | { __typename?: 'PageChooserBlock' } | { __typename?: 'QuoteBlock' } | { __typename?: 'RawHTMLBlock' } | { __typename?: 'RegexBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'StaticBlock' } | { __typename?: 'StreamBlock' } | { __typename?: 'StreamFieldBlock' } | { __typename?: 'StructBlock' } | { __typename?: 'SubMenuBlock' } | { __typename?: 'TextBlock' } | { __typename?: 'TimeBlock' } | { __typename?: 'URLBlock' } | null> | null, columnTwo?: Array<{ __typename?: 'BlockQuoteBlock' } | { __typename?: 'BooleanBlock' } | { __typename?: 'CaptionedImageBlock' } | { __typename?: 'CharBlock' } | { __typename?: 'ChoiceBlock' } | { __typename?: 'DateBlock' } | { __typename?: 'DateTimeBlock' } | { __typename?: 'DecimalBlock' } | { __typename?: 'DocumentChooserBlock' } | { __typename?: 'DoubleListBlock' } | { __typename?: 'EmailBlock' } | { __typename?: 'EmbedBlock' } | { __typename?: 'ExternalLinkBlock' } | { __typename?: 'FeaturedContentBlock' } | { __typename?: 'FloatBlock' } | { __typename?: 'ImageChooserBlock' } | { __typename?: 'IntegerBlock' } | { __typename?: 'InternalLinkBlock' } | { __typename?: 'ListBlock' } | { __typename?: 'ListItem', indentationLevel: number, text: string } | { __typename?: 'PageChooserBlock' } | { __typename?: 'QuoteBlock' } | { __typename?: 'RawHTMLBlock' } | { __typename?: 'RegexBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'StaticBlock' } | { __typename?: 'StreamBlock' } | { __typename?: 'StreamFieldBlock' } | { __typename?: 'StructBlock' } | { __typename?: 'SubMenuBlock' } | { __typename?: 'TextBlock' } | { __typename?: 'TimeBlock' } | { __typename?: 'URLBlock' } | null> | null } | { __typename?: 'EmailBlock', blockType: string } | { __typename?: 'EmbedBlock', blockType: string, embed?: string | null } | { __typename?: 'ExternalLinkBlock', blockType: string } | { __typename?: 'FeaturedContentBlock', blockType: string, title?: string | null, content: string, link?: string | null, linkText?: string | null, image?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null } | { __typename?: 'FloatBlock', blockType: string } | { __typename?: 'ImageChooserBlock', blockType: string } | { __typename?: 'IntegerBlock', blockType: string } | { __typename?: 'InternalLinkBlock', blockType: string } | { __typename?: 'ListBlock', blockType: string } | { __typename?: 'ListItem', blockType: string } | { __typename?: 'PageChooserBlock', blockType: string } | { __typename?: 'QuoteBlock', blockType: string, field: string, blocks: Array<{ __typename?: 'BlockQuoteBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'BooleanBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'CaptionedImageBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'CharBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ChoiceBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DateBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DateTimeBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DecimalBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DocumentChooserBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DoubleListBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'EmailBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'EmbedBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ExternalLinkBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'FeaturedContentBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'FloatBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ImageChooserBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'IntegerBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'InternalLinkBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ListBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ListItem', blockType: string, field: string, rawValue: string } | { __typename?: 'PageChooserBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'QuoteBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'RawHTMLBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'RegexBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'RichTextBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StaticBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StreamBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StreamFieldBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StructBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'SubMenuBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'TextBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'TimeBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'URLBlock', blockType: string, field: string, rawValue: string }> } | { __typename?: 'RawHTMLBlock', blockType: string } | { __typename?: 'RegexBlock', blockType: string } | { __typename?: 'RichTextBlock', blockType: string, id?: string | null, value: string } | { __typename?: 'StaticBlock', blockType: string } | { __typename?: 'StreamBlock', blockType: string } | { __typename?: 'StreamFieldBlock', blockType: string } | { __typename?: 'StructBlock', blockType: string } | { __typename?: 'SubMenuBlock', blockType: string } | { __typename?: 'TextBlock', blockType: string } | { __typename?: 'TimeBlock', blockType: string } | { __typename?: 'URLBlock', blockType: string } | null> | null, tags?: Array<{ __typename?: 'NewsTag', name?: string | null, slug?: string | null } | null> | null } | { __typename?: 'Page', title: string, slug: string, urlPath: string, pageType?: string | null, seoTitle: string, searchDescription?: string | null } | { __typename?: 'ProjectListingPage', title: string, slug: string, urlPath: string, pageType?: string | null, seoTitle: string, searchDescription?: string | null } | { __typename?: 'ProjectPage', title: string, slug: string, urlPath: string, pageType?: string | null, seoTitle: string, searchDescription?: string | null, subtitle?: string | null, heroCaption?: string | null, description?: string | null, searchImage?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null, heroImage?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null, body?: Array<{ __typename?: 'BlockQuoteBlock', blockType: string } | { __typename?: 'BooleanBlock', blockType: string } | { __typename?: 'CaptionedImageBlock', blockType: string, caption?: any | null, image?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null } | { __typename?: 'CharBlock', blockType: string } | { __typename?: 'ChoiceBlock', blockType: string } | { __typename?: 'DateBlock', blockType: string } | { __typename?: 'DateTimeBlock', blockType: string } | { __typename?: 'DecimalBlock', blockType: string } | { __typename?: 'DocumentChooserBlock', blockType: string } | { __typename?: 'DoubleListBlock', blockType: string, heading?: string | null, columnOne?: Array<{ __typename?: 'BlockQuoteBlock' } | { __typename?: 'BooleanBlock' } | { __typename?: 'CaptionedImageBlock' } | { __typename?: 'CharBlock' } | { __typename?: 'ChoiceBlock' } | { __typename?: 'DateBlock' } | { __typename?: 'DateTimeBlock' } | { __typename?: 'DecimalBlock' } | { __typename?: 'DocumentChooserBlock' } | { __typename?: 'DoubleListBlock' } | { __typename?: 'EmailBlock' } | { __typename?: 'EmbedBlock' } | { __typename?: 'ExternalLinkBlock' } | { __typename?: 'FeaturedContentBlock' } | { __typename?: 'FloatBlock' } | { __typename?: 'ImageChooserBlock' } | { __typename?: 'IntegerBlock' } | { __typename?: 'InternalLinkBlock' } | { __typename?: 'ListBlock' } | { __typename?: 'ListItem', indentationLevel: number, text: string } | { __typename?: 'PageChooserBlock' } | { __typename?: 'QuoteBlock' } | { __typename?: 'RawHTMLBlock' } | { __typename?: 'RegexBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'StaticBlock' } | { __typename?: 'StreamBlock' } | { __typename?: 'StreamFieldBlock' } | { __typename?: 'StructBlock' } | { __typename?: 'SubMenuBlock' } | { __typename?: 'TextBlock' } | { __typename?: 'TimeBlock' } | { __typename?: 'URLBlock' } | null> | null, columnTwo?: Array<{ __typename?: 'BlockQuoteBlock' } | { __typename?: 'BooleanBlock' } | { __typename?: 'CaptionedImageBlock' } | { __typename?: 'CharBlock' } | { __typename?: 'ChoiceBlock' } | { __typename?: 'DateBlock' } | { __typename?: 'DateTimeBlock' } | { __typename?: 'DecimalBlock' } | { __typename?: 'DocumentChooserBlock' } | { __typename?: 'DoubleListBlock' } | { __typename?: 'EmailBlock' } | { __typename?: 'EmbedBlock' } | { __typename?: 'ExternalLinkBlock' } | { __typename?: 'FeaturedContentBlock' } | { __typename?: 'FloatBlock' } | { __typename?: 'ImageChooserBlock' } | { __typename?: 'IntegerBlock' } | { __typename?: 'InternalLinkBlock' } | { __typename?: 'ListBlock' } | { __typename?: 'ListItem', indentationLevel: number, text: string } | { __typename?: 'PageChooserBlock' } | { __typename?: 'QuoteBlock' } | { __typename?: 'RawHTMLBlock' } | { __typename?: 'RegexBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'StaticBlock' } | { __typename?: 'StreamBlock' } | { __typename?: 'StreamFieldBlock' } | { __typename?: 'StructBlock' } | { __typename?: 'SubMenuBlock' } | { __typename?: 'TextBlock' } | { __typename?: 'TimeBlock' } | { __typename?: 'URLBlock' } | null> | null } | { __typename?: 'EmailBlock', blockType: string } | { __typename?: 'EmbedBlock', blockType: string, embed?: string | null } | { __typename?: 'ExternalLinkBlock', blockType: string } | { __typename?: 'FeaturedContentBlock', blockType: string, title?: string | null, content: string, link?: string | null, linkText?: string | null, image?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null } | { __typename?: 'FloatBlock', blockType: string } | { __typename?: 'ImageChooserBlock', blockType: string } | { __typename?: 'IntegerBlock', blockType: string } | { __typename?: 'InternalLinkBlock', blockType: string } | { __typename?: 'ListBlock', blockType: string } | { __typename?: 'ListItem', blockType: string } | { __typename?: 'PageChooserBlock', blockType: string } | { __typename?: 'QuoteBlock', blockType: string, field: string, blocks: Array<{ __typename?: 'BlockQuoteBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'BooleanBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'CaptionedImageBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'CharBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ChoiceBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DateBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DateTimeBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DecimalBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DocumentChooserBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DoubleListBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'EmailBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'EmbedBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ExternalLinkBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'FeaturedContentBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'FloatBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ImageChooserBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'IntegerBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'InternalLinkBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ListBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ListItem', blockType: string, field: string, rawValue: string } | { __typename?: 'PageChooserBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'QuoteBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'RawHTMLBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'RegexBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'RichTextBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StaticBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StreamBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StreamFieldBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StructBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'SubMenuBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'TextBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'TimeBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'URLBlock', blockType: string, field: string, rawValue: string }> } | { __typename?: 'RawHTMLBlock', blockType: string } | { __typename?: 'RegexBlock', blockType: string } | { __typename?: 'RichTextBlock', blockType: string, id?: string | null, value: string } | { __typename?: 'StaticBlock', blockType: string } | { __typename?: 'StreamBlock', blockType: string } | { __typename?: 'StreamFieldBlock', blockType: string } | { __typename?: 'StructBlock', blockType: string } | { __typename?: 'SubMenuBlock', blockType: string } | { __typename?: 'TextBlock', blockType: string } | { __typename?: 'TimeBlock', blockType: string } | { __typename?: 'URLBlock', blockType: string } | null> | null } | { __typename?: 'TeamPage', title: string, slug: string, urlPath: string, pageType?: string | null, seoTitle: string, searchDescription?: string | null, searchImage?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null, people?: Array<{ __typename?: 'Person', id?: string | null, name?: string | null, title?: string | null, linkedin?: string | null, location?: Array<{ __typename?: 'LocationTag', name?: string | null, slug?: string | null } | null> | null, image?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null } | null> | null } | null, sites: Array<{ __typename?: 'SiteObjectType', siteName: string, hostname: string }>, analyticsSettings?: { __typename?: 'AnalyticsSettings', script?: string | null } | null };

export type TeamPageFragment = { __typename?: 'TeamPage', people?: Array<{ __typename?: 'Person', id?: string | null, name?: string | null, title?: string | null, linkedin?: string | null, location?: Array<{ __typename?: 'LocationTag', name?: string | null, slug?: string | null } | null> | null, image?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null } | null> | null };

export type ProjectPageFragment = { __typename?: 'ProjectPage', subtitle?: string | null, heroCaption?: string | null, description?: string | null, heroImage?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null, body?: Array<{ __typename?: 'BlockQuoteBlock', blockType: string } | { __typename?: 'BooleanBlock', blockType: string } | { __typename?: 'CaptionedImageBlock', blockType: string, caption?: any | null, image?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null } | { __typename?: 'CharBlock', blockType: string } | { __typename?: 'ChoiceBlock', blockType: string } | { __typename?: 'DateBlock', blockType: string } | { __typename?: 'DateTimeBlock', blockType: string } | { __typename?: 'DecimalBlock', blockType: string } | { __typename?: 'DocumentChooserBlock', blockType: string } | { __typename?: 'DoubleListBlock', blockType: string, heading?: string | null, columnOne?: Array<{ __typename?: 'BlockQuoteBlock' } | { __typename?: 'BooleanBlock' } | { __typename?: 'CaptionedImageBlock' } | { __typename?: 'CharBlock' } | { __typename?: 'ChoiceBlock' } | { __typename?: 'DateBlock' } | { __typename?: 'DateTimeBlock' } | { __typename?: 'DecimalBlock' } | { __typename?: 'DocumentChooserBlock' } | { __typename?: 'DoubleListBlock' } | { __typename?: 'EmailBlock' } | { __typename?: 'EmbedBlock' } | { __typename?: 'ExternalLinkBlock' } | { __typename?: 'FeaturedContentBlock' } | { __typename?: 'FloatBlock' } | { __typename?: 'ImageChooserBlock' } | { __typename?: 'IntegerBlock' } | { __typename?: 'InternalLinkBlock' } | { __typename?: 'ListBlock' } | { __typename?: 'ListItem', indentationLevel: number, text: string } | { __typename?: 'PageChooserBlock' } | { __typename?: 'QuoteBlock' } | { __typename?: 'RawHTMLBlock' } | { __typename?: 'RegexBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'StaticBlock' } | { __typename?: 'StreamBlock' } | { __typename?: 'StreamFieldBlock' } | { __typename?: 'StructBlock' } | { __typename?: 'SubMenuBlock' } | { __typename?: 'TextBlock' } | { __typename?: 'TimeBlock' } | { __typename?: 'URLBlock' } | null> | null, columnTwo?: Array<{ __typename?: 'BlockQuoteBlock' } | { __typename?: 'BooleanBlock' } | { __typename?: 'CaptionedImageBlock' } | { __typename?: 'CharBlock' } | { __typename?: 'ChoiceBlock' } | { __typename?: 'DateBlock' } | { __typename?: 'DateTimeBlock' } | { __typename?: 'DecimalBlock' } | { __typename?: 'DocumentChooserBlock' } | { __typename?: 'DoubleListBlock' } | { __typename?: 'EmailBlock' } | { __typename?: 'EmbedBlock' } | { __typename?: 'ExternalLinkBlock' } | { __typename?: 'FeaturedContentBlock' } | { __typename?: 'FloatBlock' } | { __typename?: 'ImageChooserBlock' } | { __typename?: 'IntegerBlock' } | { __typename?: 'InternalLinkBlock' } | { __typename?: 'ListBlock' } | { __typename?: 'ListItem', indentationLevel: number, text: string } | { __typename?: 'PageChooserBlock' } | { __typename?: 'QuoteBlock' } | { __typename?: 'RawHTMLBlock' } | { __typename?: 'RegexBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'StaticBlock' } | { __typename?: 'StreamBlock' } | { __typename?: 'StreamFieldBlock' } | { __typename?: 'StructBlock' } | { __typename?: 'SubMenuBlock' } | { __typename?: 'TextBlock' } | { __typename?: 'TimeBlock' } | { __typename?: 'URLBlock' } | null> | null } | { __typename?: 'EmailBlock', blockType: string } | { __typename?: 'EmbedBlock', blockType: string, embed?: string | null } | { __typename?: 'ExternalLinkBlock', blockType: string } | { __typename?: 'FeaturedContentBlock', blockType: string, title?: string | null, content: string, link?: string | null, linkText?: string | null, image?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null } | { __typename?: 'FloatBlock', blockType: string } | { __typename?: 'ImageChooserBlock', blockType: string } | { __typename?: 'IntegerBlock', blockType: string } | { __typename?: 'InternalLinkBlock', blockType: string } | { __typename?: 'ListBlock', blockType: string } | { __typename?: 'ListItem', blockType: string } | { __typename?: 'PageChooserBlock', blockType: string } | { __typename?: 'QuoteBlock', blockType: string, field: string, blocks: Array<{ __typename?: 'BlockQuoteBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'BooleanBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'CaptionedImageBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'CharBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ChoiceBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DateBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DateTimeBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DecimalBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DocumentChooserBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DoubleListBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'EmailBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'EmbedBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ExternalLinkBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'FeaturedContentBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'FloatBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ImageChooserBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'IntegerBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'InternalLinkBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ListBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ListItem', blockType: string, field: string, rawValue: string } | { __typename?: 'PageChooserBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'QuoteBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'RawHTMLBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'RegexBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'RichTextBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StaticBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StreamBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StreamFieldBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StructBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'SubMenuBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'TextBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'TimeBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'URLBlock', blockType: string, field: string, rawValue: string }> } | { __typename?: 'RawHTMLBlock', blockType: string } | { __typename?: 'RegexBlock', blockType: string } | { __typename?: 'RichTextBlock', blockType: string, id?: string | null, value: string } | { __typename?: 'StaticBlock', blockType: string } | { __typename?: 'StreamBlock', blockType: string } | { __typename?: 'StreamFieldBlock', blockType: string } | { __typename?: 'StructBlock', blockType: string } | { __typename?: 'SubMenuBlock', blockType: string } | { __typename?: 'TextBlock', blockType: string } | { __typename?: 'TimeBlock', blockType: string } | { __typename?: 'URLBlock', blockType: string } | null> | null };

export type ContentPageFragment = { __typename?: 'ContentPage', subtitle?: string | null, heroCaption?: string | null, heroImage?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null, body?: Array<{ __typename?: 'BlockQuoteBlock', blockType: string } | { __typename?: 'BooleanBlock', blockType: string } | { __typename?: 'CaptionedImageBlock', blockType: string, caption?: any | null, image?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null } | { __typename?: 'CharBlock', blockType: string } | { __typename?: 'ChoiceBlock', blockType: string } | { __typename?: 'DateBlock', blockType: string } | { __typename?: 'DateTimeBlock', blockType: string } | { __typename?: 'DecimalBlock', blockType: string } | { __typename?: 'DocumentChooserBlock', blockType: string } | { __typename?: 'DoubleListBlock', blockType: string, heading?: string | null, columnOne?: Array<{ __typename?: 'BlockQuoteBlock' } | { __typename?: 'BooleanBlock' } | { __typename?: 'CaptionedImageBlock' } | { __typename?: 'CharBlock' } | { __typename?: 'ChoiceBlock' } | { __typename?: 'DateBlock' } | { __typename?: 'DateTimeBlock' } | { __typename?: 'DecimalBlock' } | { __typename?: 'DocumentChooserBlock' } | { __typename?: 'DoubleListBlock' } | { __typename?: 'EmailBlock' } | { __typename?: 'EmbedBlock' } | { __typename?: 'ExternalLinkBlock' } | { __typename?: 'FeaturedContentBlock' } | { __typename?: 'FloatBlock' } | { __typename?: 'ImageChooserBlock' } | { __typename?: 'IntegerBlock' } | { __typename?: 'InternalLinkBlock' } | { __typename?: 'ListBlock' } | { __typename?: 'ListItem', indentationLevel: number, text: string } | { __typename?: 'PageChooserBlock' } | { __typename?: 'QuoteBlock' } | { __typename?: 'RawHTMLBlock' } | { __typename?: 'RegexBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'StaticBlock' } | { __typename?: 'StreamBlock' } | { __typename?: 'StreamFieldBlock' } | { __typename?: 'StructBlock' } | { __typename?: 'SubMenuBlock' } | { __typename?: 'TextBlock' } | { __typename?: 'TimeBlock' } | { __typename?: 'URLBlock' } | null> | null, columnTwo?: Array<{ __typename?: 'BlockQuoteBlock' } | { __typename?: 'BooleanBlock' } | { __typename?: 'CaptionedImageBlock' } | { __typename?: 'CharBlock' } | { __typename?: 'ChoiceBlock' } | { __typename?: 'DateBlock' } | { __typename?: 'DateTimeBlock' } | { __typename?: 'DecimalBlock' } | { __typename?: 'DocumentChooserBlock' } | { __typename?: 'DoubleListBlock' } | { __typename?: 'EmailBlock' } | { __typename?: 'EmbedBlock' } | { __typename?: 'ExternalLinkBlock' } | { __typename?: 'FeaturedContentBlock' } | { __typename?: 'FloatBlock' } | { __typename?: 'ImageChooserBlock' } | { __typename?: 'IntegerBlock' } | { __typename?: 'InternalLinkBlock' } | { __typename?: 'ListBlock' } | { __typename?: 'ListItem', indentationLevel: number, text: string } | { __typename?: 'PageChooserBlock' } | { __typename?: 'QuoteBlock' } | { __typename?: 'RawHTMLBlock' } | { __typename?: 'RegexBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'StaticBlock' } | { __typename?: 'StreamBlock' } | { __typename?: 'StreamFieldBlock' } | { __typename?: 'StructBlock' } | { __typename?: 'SubMenuBlock' } | { __typename?: 'TextBlock' } | { __typename?: 'TimeBlock' } | { __typename?: 'URLBlock' } | null> | null } | { __typename?: 'EmailBlock', blockType: string } | { __typename?: 'EmbedBlock', blockType: string, embed?: string | null } | { __typename?: 'ExternalLinkBlock', blockType: string } | { __typename?: 'FeaturedContentBlock', blockType: string, title?: string | null, content: string, link?: string | null, linkText?: string | null, image?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null } | { __typename?: 'FloatBlock', blockType: string } | { __typename?: 'ImageChooserBlock', blockType: string } | { __typename?: 'IntegerBlock', blockType: string } | { __typename?: 'InternalLinkBlock', blockType: string } | { __typename?: 'ListBlock', blockType: string } | { __typename?: 'ListItem', blockType: string } | { __typename?: 'PageChooserBlock', blockType: string } | { __typename?: 'QuoteBlock', blockType: string, field: string, blocks: Array<{ __typename?: 'BlockQuoteBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'BooleanBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'CaptionedImageBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'CharBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ChoiceBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DateBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DateTimeBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DecimalBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DocumentChooserBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DoubleListBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'EmailBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'EmbedBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ExternalLinkBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'FeaturedContentBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'FloatBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ImageChooserBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'IntegerBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'InternalLinkBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ListBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ListItem', blockType: string, field: string, rawValue: string } | { __typename?: 'PageChooserBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'QuoteBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'RawHTMLBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'RegexBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'RichTextBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StaticBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StreamBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StreamFieldBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StructBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'SubMenuBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'TextBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'TimeBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'URLBlock', blockType: string, field: string, rawValue: string }> } | { __typename?: 'RawHTMLBlock', blockType: string } | { __typename?: 'RegexBlock', blockType: string } | { __typename?: 'RichTextBlock', blockType: string, id?: string | null, value: string } | { __typename?: 'StaticBlock', blockType: string } | { __typename?: 'StreamBlock', blockType: string } | { __typename?: 'StreamFieldBlock', blockType: string } | { __typename?: 'StructBlock', blockType: string } | { __typename?: 'SubMenuBlock', blockType: string } | { __typename?: 'TextBlock', blockType: string } | { __typename?: 'TimeBlock', blockType: string } | { __typename?: 'URLBlock', blockType: string } | null> | null };

export type NewsIndexFragment = { __typename?: 'NewsIndex', title: string, tags?: Array<{ __typename?: 'NewsTag', name?: string | null, slug?: string | null, isTagged?: boolean | null } | null> | null };

export type NewsPageFragment = { __typename?: 'NewsPage', subtitle?: string | null, heroCaption?: string | null, heroImage?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null, body?: Array<{ __typename?: 'BlockQuoteBlock', blockType: string } | { __typename?: 'BooleanBlock', blockType: string } | { __typename?: 'CaptionedImageBlock', blockType: string, caption?: any | null, image?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null } | { __typename?: 'CharBlock', blockType: string } | { __typename?: 'ChoiceBlock', blockType: string } | { __typename?: 'DateBlock', blockType: string } | { __typename?: 'DateTimeBlock', blockType: string } | { __typename?: 'DecimalBlock', blockType: string } | { __typename?: 'DocumentChooserBlock', blockType: string } | { __typename?: 'DoubleListBlock', blockType: string, heading?: string | null, columnOne?: Array<{ __typename?: 'BlockQuoteBlock' } | { __typename?: 'BooleanBlock' } | { __typename?: 'CaptionedImageBlock' } | { __typename?: 'CharBlock' } | { __typename?: 'ChoiceBlock' } | { __typename?: 'DateBlock' } | { __typename?: 'DateTimeBlock' } | { __typename?: 'DecimalBlock' } | { __typename?: 'DocumentChooserBlock' } | { __typename?: 'DoubleListBlock' } | { __typename?: 'EmailBlock' } | { __typename?: 'EmbedBlock' } | { __typename?: 'ExternalLinkBlock' } | { __typename?: 'FeaturedContentBlock' } | { __typename?: 'FloatBlock' } | { __typename?: 'ImageChooserBlock' } | { __typename?: 'IntegerBlock' } | { __typename?: 'InternalLinkBlock' } | { __typename?: 'ListBlock' } | { __typename?: 'ListItem', indentationLevel: number, text: string } | { __typename?: 'PageChooserBlock' } | { __typename?: 'QuoteBlock' } | { __typename?: 'RawHTMLBlock' } | { __typename?: 'RegexBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'StaticBlock' } | { __typename?: 'StreamBlock' } | { __typename?: 'StreamFieldBlock' } | { __typename?: 'StructBlock' } | { __typename?: 'SubMenuBlock' } | { __typename?: 'TextBlock' } | { __typename?: 'TimeBlock' } | { __typename?: 'URLBlock' } | null> | null, columnTwo?: Array<{ __typename?: 'BlockQuoteBlock' } | { __typename?: 'BooleanBlock' } | { __typename?: 'CaptionedImageBlock' } | { __typename?: 'CharBlock' } | { __typename?: 'ChoiceBlock' } | { __typename?: 'DateBlock' } | { __typename?: 'DateTimeBlock' } | { __typename?: 'DecimalBlock' } | { __typename?: 'DocumentChooserBlock' } | { __typename?: 'DoubleListBlock' } | { __typename?: 'EmailBlock' } | { __typename?: 'EmbedBlock' } | { __typename?: 'ExternalLinkBlock' } | { __typename?: 'FeaturedContentBlock' } | { __typename?: 'FloatBlock' } | { __typename?: 'ImageChooserBlock' } | { __typename?: 'IntegerBlock' } | { __typename?: 'InternalLinkBlock' } | { __typename?: 'ListBlock' } | { __typename?: 'ListItem', indentationLevel: number, text: string } | { __typename?: 'PageChooserBlock' } | { __typename?: 'QuoteBlock' } | { __typename?: 'RawHTMLBlock' } | { __typename?: 'RegexBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'StaticBlock' } | { __typename?: 'StreamBlock' } | { __typename?: 'StreamFieldBlock' } | { __typename?: 'StructBlock' } | { __typename?: 'SubMenuBlock' } | { __typename?: 'TextBlock' } | { __typename?: 'TimeBlock' } | { __typename?: 'URLBlock' } | null> | null } | { __typename?: 'EmailBlock', blockType: string } | { __typename?: 'EmbedBlock', blockType: string, embed?: string | null } | { __typename?: 'ExternalLinkBlock', blockType: string } | { __typename?: 'FeaturedContentBlock', blockType: string, title?: string | null, content: string, link?: string | null, linkText?: string | null, image?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null } | { __typename?: 'FloatBlock', blockType: string } | { __typename?: 'ImageChooserBlock', blockType: string } | { __typename?: 'IntegerBlock', blockType: string } | { __typename?: 'InternalLinkBlock', blockType: string } | { __typename?: 'ListBlock', blockType: string } | { __typename?: 'ListItem', blockType: string } | { __typename?: 'PageChooserBlock', blockType: string } | { __typename?: 'QuoteBlock', blockType: string, field: string, blocks: Array<{ __typename?: 'BlockQuoteBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'BooleanBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'CaptionedImageBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'CharBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ChoiceBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DateBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DateTimeBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DecimalBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DocumentChooserBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DoubleListBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'EmailBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'EmbedBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ExternalLinkBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'FeaturedContentBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'FloatBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ImageChooserBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'IntegerBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'InternalLinkBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ListBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ListItem', blockType: string, field: string, rawValue: string } | { __typename?: 'PageChooserBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'QuoteBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'RawHTMLBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'RegexBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'RichTextBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StaticBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StreamBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StreamFieldBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StructBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'SubMenuBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'TextBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'TimeBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'URLBlock', blockType: string, field: string, rawValue: string }> } | { __typename?: 'RawHTMLBlock', blockType: string } | { __typename?: 'RegexBlock', blockType: string } | { __typename?: 'RichTextBlock', blockType: string, id?: string | null, value: string } | { __typename?: 'StaticBlock', blockType: string } | { __typename?: 'StreamBlock', blockType: string } | { __typename?: 'StreamFieldBlock', blockType: string } | { __typename?: 'StructBlock', blockType: string } | { __typename?: 'SubMenuBlock', blockType: string } | { __typename?: 'TextBlock', blockType: string } | { __typename?: 'TimeBlock', blockType: string } | { __typename?: 'URLBlock', blockType: string } | null> | null, tags?: Array<{ __typename?: 'NewsTag', name?: string | null, slug?: string | null } | null> | null };

export type RichTextFragment = { __typename?: 'RichTextBlock', id?: string | null, value: string };

export type FeaturedContentFragment = { __typename?: 'FeaturedContentBlock', title?: string | null, content: string, link?: string | null, linkText?: string | null, image?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null };

export type CaptionedImageFragment = { __typename?: 'CaptionedImageBlock', caption?: any | null, image?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null };

export type VideoFragment = { __typename?: 'EmbedBlock', embed?: string | null };

export type QuoteBlockFragment = { __typename?: 'QuoteBlock', field: string, blocks: Array<{ __typename?: 'BlockQuoteBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'BooleanBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'CaptionedImageBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'CharBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ChoiceBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DateBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DateTimeBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DecimalBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DocumentChooserBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'DoubleListBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'EmailBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'EmbedBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ExternalLinkBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'FeaturedContentBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'FloatBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ImageChooserBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'IntegerBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'InternalLinkBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ListBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'ListItem', blockType: string, field: string, rawValue: string } | { __typename?: 'PageChooserBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'QuoteBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'RawHTMLBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'RegexBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'RichTextBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StaticBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StreamBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StreamFieldBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'StructBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'SubMenuBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'TextBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'TimeBlock', blockType: string, field: string, rawValue: string } | { __typename?: 'URLBlock', blockType: string, field: string, rawValue: string }> };

export type ListItemFragment = { __typename?: 'ListItem', indentationLevel: number, text: string };

export type DoubleListBlockFragment = { __typename?: 'DoubleListBlock', heading?: string | null, columnOne?: Array<{ __typename?: 'BlockQuoteBlock' } | { __typename?: 'BooleanBlock' } | { __typename?: 'CaptionedImageBlock' } | { __typename?: 'CharBlock' } | { __typename?: 'ChoiceBlock' } | { __typename?: 'DateBlock' } | { __typename?: 'DateTimeBlock' } | { __typename?: 'DecimalBlock' } | { __typename?: 'DocumentChooserBlock' } | { __typename?: 'DoubleListBlock' } | { __typename?: 'EmailBlock' } | { __typename?: 'EmbedBlock' } | { __typename?: 'ExternalLinkBlock' } | { __typename?: 'FeaturedContentBlock' } | { __typename?: 'FloatBlock' } | { __typename?: 'ImageChooserBlock' } | { __typename?: 'IntegerBlock' } | { __typename?: 'InternalLinkBlock' } | { __typename?: 'ListBlock' } | { __typename?: 'ListItem', indentationLevel: number, text: string } | { __typename?: 'PageChooserBlock' } | { __typename?: 'QuoteBlock' } | { __typename?: 'RawHTMLBlock' } | { __typename?: 'RegexBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'StaticBlock' } | { __typename?: 'StreamBlock' } | { __typename?: 'StreamFieldBlock' } | { __typename?: 'StructBlock' } | { __typename?: 'SubMenuBlock' } | { __typename?: 'TextBlock' } | { __typename?: 'TimeBlock' } | { __typename?: 'URLBlock' } | null> | null, columnTwo?: Array<{ __typename?: 'BlockQuoteBlock' } | { __typename?: 'BooleanBlock' } | { __typename?: 'CaptionedImageBlock' } | { __typename?: 'CharBlock' } | { __typename?: 'ChoiceBlock' } | { __typename?: 'DateBlock' } | { __typename?: 'DateTimeBlock' } | { __typename?: 'DecimalBlock' } | { __typename?: 'DocumentChooserBlock' } | { __typename?: 'DoubleListBlock' } | { __typename?: 'EmailBlock' } | { __typename?: 'EmbedBlock' } | { __typename?: 'ExternalLinkBlock' } | { __typename?: 'FeaturedContentBlock' } | { __typename?: 'FloatBlock' } | { __typename?: 'ImageChooserBlock' } | { __typename?: 'IntegerBlock' } | { __typename?: 'InternalLinkBlock' } | { __typename?: 'ListBlock' } | { __typename?: 'ListItem', indentationLevel: number, text: string } | { __typename?: 'PageChooserBlock' } | { __typename?: 'QuoteBlock' } | { __typename?: 'RawHTMLBlock' } | { __typename?: 'RegexBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'StaticBlock' } | { __typename?: 'StreamBlock' } | { __typename?: 'StreamFieldBlock' } | { __typename?: 'StructBlock' } | { __typename?: 'SubMenuBlock' } | { __typename?: 'TextBlock' } | { __typename?: 'TimeBlock' } | { __typename?: 'URLBlock' } | null> | null };

export type ImageRenditionFieldsFragment = { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } };

export type GetNewsListingQueryVariables = Exact<{
  page?: InputMaybe<Scalars['PositiveInt']>;
  perPage?: InputMaybe<Scalars['PositiveInt']>;
  tags?: InputMaybe<Scalars['String']>;
}>;


export type GetNewsListingQuery = { __typename?: 'Query', newsPages?: { __typename?: 'NewsPagePaginatedType', items?: Array<{ __typename?: 'NewsPage', id?: string | null, title: string, urlPath: string, tags?: Array<{ __typename?: 'NewsTag', name?: string | null, slug?: string | null } | null> | null, heroImage?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null } | null> | null, pagination?: { __typename?: 'PaginationType', total: any } | null } | null };

export type GetProjectListingQueryVariables = Exact<{
  page?: InputMaybe<Scalars['PositiveInt']>;
  perPage?: InputMaybe<Scalars['PositiveInt']>;
}>;


export type GetProjectListingQuery = { __typename?: 'Query', projectPages?: { __typename?: 'ProjectPagePaginatedType', pagination?: { __typename?: 'PaginationType', total: any } | null, items?: Array<{ __typename?: 'ProjectPage', title: string, description?: string | null, urlPath: string, heroImage?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null } | null> | null } | null };

export type AllPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPagesQuery = { __typename?: 'Query', pages: Array<{ __typename?: 'ContentPage', slug: string, title: string, id?: string | null, live: boolean, urlPath: string, pageType?: string | null } | { __typename?: 'HomePage', slug: string, title: string, id?: string | null, live: boolean, urlPath: string, pageType?: string | null } | { __typename?: 'NewsIndex', slug: string, title: string, id?: string | null, live: boolean, urlPath: string, pageType?: string | null } | { __typename?: 'NewsPage', slug: string, title: string, id?: string | null, live: boolean, urlPath: string, pageType?: string | null } | { __typename?: 'Page', slug: string, title: string, id?: string | null, live: boolean, urlPath: string, pageType?: string | null } | { __typename?: 'ProjectListingPage', slug: string, title: string, id?: string | null, live: boolean, urlPath: string, pageType?: string | null } | { __typename?: 'ProjectPage', slug: string, title: string, id?: string | null, live: boolean, urlPath: string, pageType?: string | null } | { __typename?: 'TeamPage', slug: string, title: string, id?: string | null, live: boolean, urlPath: string, pageType?: string | null }> };

export type HomePageQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']>;
}>;


export type HomePageQuery = { __typename?: 'Query', home: { __typename?: 'HomePage', path: string, title: string, slug: string, seoTitle: string, searchDescription?: string | null, ctaText?: string | null, explainer?: string | null, introText?: string | null, tagline?: string | null, searchImage?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null, ctaLink?: { __typename?: 'ContentPage', title: string, url?: string | null } | { __typename?: 'HomePage', title: string, url?: string | null } | { __typename?: 'NewsIndex', title: string, url?: string | null } | { __typename?: 'NewsPage', title: string, url?: string | null } | { __typename?: 'Page', title: string, url?: string | null } | { __typename?: 'ProjectListingPage', title: string, url?: string | null } | { __typename?: 'ProjectPage', title: string, url?: string | null } | { __typename?: 'TeamPage', title: string, url?: string | null } | null, heroImage?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null, subrands?: Array<{ __typename?: 'Subrand', name?: string | null, description?: string | null, image?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null, link?: { __typename?: 'ContentPage', title: string, urlPath: string } | { __typename?: 'HomePage', title: string, urlPath: string } | { __typename?: 'NewsIndex', title: string, urlPath: string } | { __typename?: 'NewsPage', title: string, urlPath: string } | { __typename?: 'Page', title: string, urlPath: string } | { __typename?: 'ProjectListingPage', title: string, urlPath: string } | { __typename?: 'ProjectPage', title: string, urlPath: string } | { __typename?: 'TeamPage', title: string, urlPath: string } | null, products?: Array<{ __typename?: 'SubrandProduct', name?: string | null, page?: { __typename?: 'ContentPage', urlPath: string, title: string } | { __typename?: 'HomePage', urlPath: string, title: string } | { __typename?: 'NewsIndex', urlPath: string, title: string } | { __typename?: 'NewsPage', urlPath: string, title: string } | { __typename?: 'Page', urlPath: string, title: string } | { __typename?: 'ProjectListingPage', urlPath: string, title: string } | { __typename?: 'ProjectPage', urlPath: string, title: string } | { __typename?: 'TeamPage', urlPath: string, title: string } | null } | null> | null } | null> | null, projectListing?: { __typename?: 'ContentPage', title: string, url?: string | null } | { __typename?: 'HomePage', title: string, url?: string | null } | { __typename?: 'NewsIndex', title: string, url?: string | null } | { __typename?: 'NewsPage', title: string, url?: string | null } | { __typename?: 'Page', title: string, url?: string | null } | { __typename?: 'ProjectListingPage', title: string, url?: string | null } | { __typename?: 'ProjectPage', title: string, url?: string | null } | { __typename?: 'TeamPage', title: string, url?: string | null } | null, featuredProjects?: Array<{ __typename?: 'FeaturedProject', project?: { __typename?: 'ContentPage' } | { __typename?: 'HomePage' } | { __typename?: 'NewsIndex' } | { __typename?: 'NewsPage' } | { __typename?: 'Page' } | { __typename?: 'ProjectListingPage' } | { __typename?: 'ProjectPage', title: string, urlPath: string, heroImage?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null } | { __typename?: 'TeamPage' } | null } | null> | null, newsListing?: { __typename?: 'ContentPage', title: string, url?: string | null } | { __typename?: 'HomePage', title: string, url?: string | null } | { __typename?: 'NewsIndex', title: string, url?: string | null } | { __typename?: 'NewsPage', title: string, url?: string | null } | { __typename?: 'Page', title: string, url?: string | null } | { __typename?: 'ProjectListingPage', title: string, url?: string | null } | { __typename?: 'ProjectPage', title: string, url?: string | null } | { __typename?: 'TeamPage', title: string, url?: string | null } | null, featuredNews?: Array<{ __typename?: 'FeaturedNews', news?: { __typename?: 'ContentPage' } | { __typename?: 'HomePage' } | { __typename?: 'NewsIndex' } | { __typename?: 'NewsPage', title: string, urlPath: string, tags?: Array<{ __typename?: 'NewsTag', name?: string | null, slug?: string | null } | null> | null, heroImage?: { __typename?: 'ImageObjectType', rendition?: { __typename?: 'ImageRenditionObjectType', url: string, width: number, height: number, image: { __typename?: 'ImageObjectType', title: string } } | null } | null } | { __typename?: 'Page' } | { __typename?: 'ProjectListingPage' } | { __typename?: 'ProjectPage' } | { __typename?: 'TeamPage' } | null } | null> | null }, sites: Array<{ __typename?: 'SiteObjectType', siteName: string, hostname: string }>, analyticsSettings?: { __typename?: 'AnalyticsSettings', script?: string | null } | null };

export type GetHeaderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHeaderQuery = { __typename?: 'Query', menuSettings?: { __typename?: 'MenuSettings', subrandLinks?: Array<{ __typename?: 'BlockQuoteBlock', id?: string | null, blockType: string } | { __typename?: 'BooleanBlock', id?: string | null, blockType: string } | { __typename?: 'CaptionedImageBlock', id?: string | null, blockType: string } | { __typename?: 'CharBlock', id?: string | null, blockType: string } | { __typename?: 'ChoiceBlock', id?: string | null, blockType: string } | { __typename?: 'DateBlock', id?: string | null, blockType: string } | { __typename?: 'DateTimeBlock', id?: string | null, blockType: string } | { __typename?: 'DecimalBlock', id?: string | null, blockType: string } | { __typename?: 'DocumentChooserBlock', id?: string | null, blockType: string } | { __typename?: 'DoubleListBlock', id?: string | null, blockType: string } | { __typename?: 'EmailBlock', id?: string | null, blockType: string } | { __typename?: 'EmbedBlock', id?: string | null, blockType: string } | { __typename?: 'ExternalLinkBlock', id?: string | null, blockType: string } | { __typename?: 'FeaturedContentBlock', id?: string | null, blockType: string } | { __typename?: 'FloatBlock', id?: string | null, blockType: string } | { __typename?: 'ImageChooserBlock', id?: string | null, blockType: string } | { __typename?: 'IntegerBlock', id?: string | null, blockType: string } | { __typename?: 'InternalLinkBlock', id?: string | null, blockType: string, href: string, text: string } | { __typename?: 'ListBlock', id?: string | null, blockType: string } | { __typename?: 'ListItem', id?: string | null, blockType: string } | { __typename?: 'PageChooserBlock', id?: string | null, blockType: string } | { __typename?: 'QuoteBlock', id?: string | null, blockType: string } | { __typename?: 'RawHTMLBlock', id?: string | null, blockType: string } | { __typename?: 'RegexBlock', id?: string | null, blockType: string } | { __typename?: 'RichTextBlock', id?: string | null, blockType: string } | { __typename?: 'StaticBlock', id?: string | null, blockType: string } | { __typename?: 'StreamBlock', id?: string | null, blockType: string } | { __typename?: 'StreamFieldBlock', id?: string | null, blockType: string } | { __typename?: 'StructBlock', id?: string | null, blockType: string } | { __typename?: 'SubMenuBlock', id?: string | null, blockType: string } | { __typename?: 'TextBlock', id?: string | null, blockType: string } | { __typename?: 'TimeBlock', id?: string | null, blockType: string } | { __typename?: 'URLBlock', id?: string | null, blockType: string } | null> | null } | null };

export type GetFooterQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFooterQuery = { __typename?: 'Query', footerSettings?: { __typename?: 'FooterSettings', ctaText?: string | null, ctaEmail?: string | null, links?: Array<{ __typename?: 'BlockQuoteBlock', id?: string | null, blockType: string } | { __typename?: 'BooleanBlock', id?: string | null, blockType: string } | { __typename?: 'CaptionedImageBlock', id?: string | null, blockType: string } | { __typename?: 'CharBlock', id?: string | null, blockType: string } | { __typename?: 'ChoiceBlock', id?: string | null, blockType: string } | { __typename?: 'DateBlock', id?: string | null, blockType: string } | { __typename?: 'DateTimeBlock', id?: string | null, blockType: string } | { __typename?: 'DecimalBlock', id?: string | null, blockType: string } | { __typename?: 'DocumentChooserBlock', id?: string | null, blockType: string } | { __typename?: 'DoubleListBlock', id?: string | null, blockType: string } | { __typename?: 'EmailBlock', id?: string | null, blockType: string } | { __typename?: 'EmbedBlock', id?: string | null, blockType: string } | { __typename?: 'ExternalLinkBlock', id?: string | null, blockType: string, href: string, text: string } | { __typename?: 'FeaturedContentBlock', id?: string | null, blockType: string } | { __typename?: 'FloatBlock', id?: string | null, blockType: string } | { __typename?: 'ImageChooserBlock', id?: string | null, blockType: string } | { __typename?: 'IntegerBlock', id?: string | null, blockType: string } | { __typename?: 'InternalLinkBlock', id?: string | null, blockType: string, href: string, text: string } | { __typename?: 'ListBlock', id?: string | null, blockType: string } | { __typename?: 'ListItem', id?: string | null, blockType: string } | { __typename?: 'PageChooserBlock', id?: string | null, blockType: string } | { __typename?: 'QuoteBlock', id?: string | null, blockType: string } | { __typename?: 'RawHTMLBlock', id?: string | null, blockType: string } | { __typename?: 'RegexBlock', id?: string | null, blockType: string } | { __typename?: 'RichTextBlock', id?: string | null, blockType: string } | { __typename?: 'StaticBlock', id?: string | null, blockType: string } | { __typename?: 'StreamBlock', id?: string | null, blockType: string } | { __typename?: 'StreamFieldBlock', id?: string | null, blockType: string } | { __typename?: 'StructBlock', id?: string | null, blockType: string } | { __typename?: 'SubMenuBlock', id?: string | null, blockType: string } | { __typename?: 'TextBlock', id?: string | null, blockType: string } | { __typename?: 'TimeBlock', id?: string | null, blockType: string } | { __typename?: 'URLBlock', id?: string | null, blockType: string } | null> | null } | null };

export type GetMenuQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMenuQuery = { __typename?: 'Query', menuSettings?: { __typename?: 'MenuSettings', menu?: Array<{ __typename?: 'BlockQuoteBlock', id?: string | null, blockType: string } | { __typename?: 'BooleanBlock', id?: string | null, blockType: string } | { __typename?: 'CaptionedImageBlock', id?: string | null, blockType: string } | { __typename?: 'CharBlock', id?: string | null, blockType: string } | { __typename?: 'ChoiceBlock', id?: string | null, blockType: string } | { __typename?: 'DateBlock', id?: string | null, blockType: string } | { __typename?: 'DateTimeBlock', id?: string | null, blockType: string } | { __typename?: 'DecimalBlock', id?: string | null, blockType: string } | { __typename?: 'DocumentChooserBlock', id?: string | null, blockType: string } | { __typename?: 'DoubleListBlock', id?: string | null, blockType: string } | { __typename?: 'EmailBlock', id?: string | null, blockType: string } | { __typename?: 'EmbedBlock', id?: string | null, blockType: string } | { __typename?: 'ExternalLinkBlock', id?: string | null, blockType: string, href: string, text: string } | { __typename?: 'FeaturedContentBlock', id?: string | null, blockType: string } | { __typename?: 'FloatBlock', id?: string | null, blockType: string } | { __typename?: 'ImageChooserBlock', id?: string | null, blockType: string } | { __typename?: 'IntegerBlock', id?: string | null, blockType: string } | { __typename?: 'InternalLinkBlock', id?: string | null, blockType: string, href: string, text: string } | { __typename?: 'ListBlock', id?: string | null, blockType: string } | { __typename?: 'ListItem', id?: string | null, blockType: string } | { __typename?: 'PageChooserBlock', id?: string | null, blockType: string } | { __typename?: 'QuoteBlock', id?: string | null, blockType: string } | { __typename?: 'RawHTMLBlock', id?: string | null, blockType: string } | { __typename?: 'RegexBlock', id?: string | null, blockType: string } | { __typename?: 'RichTextBlock', id?: string | null, blockType: string } | { __typename?: 'StaticBlock', id?: string | null, blockType: string } | { __typename?: 'StreamBlock', id?: string | null, blockType: string } | { __typename?: 'StreamFieldBlock', id?: string | null, blockType: string } | { __typename?: 'StructBlock', id?: string | null, blockType: string } | { __typename?: 'SubMenuBlock', text: string, href: string, id?: string | null, blockType: string, items?: Array<{ __typename?: 'BlockQuoteBlock' } | { __typename?: 'BooleanBlock' } | { __typename?: 'CaptionedImageBlock' } | { __typename?: 'CharBlock' } | { __typename?: 'ChoiceBlock' } | { __typename?: 'DateBlock' } | { __typename?: 'DateTimeBlock' } | { __typename?: 'DecimalBlock' } | { __typename?: 'DocumentChooserBlock' } | { __typename?: 'DoubleListBlock' } | { __typename?: 'EmailBlock' } | { __typename?: 'EmbedBlock' } | { __typename?: 'ExternalLinkBlock', href: string, text: string } | { __typename?: 'FeaturedContentBlock' } | { __typename?: 'FloatBlock' } | { __typename?: 'ImageChooserBlock' } | { __typename?: 'IntegerBlock' } | { __typename?: 'InternalLinkBlock', href: string, text: string } | { __typename?: 'ListBlock' } | { __typename?: 'ListItem' } | { __typename?: 'PageChooserBlock' } | { __typename?: 'QuoteBlock' } | { __typename?: 'RawHTMLBlock' } | { __typename?: 'RegexBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'StaticBlock' } | { __typename?: 'StreamBlock' } | { __typename?: 'StreamFieldBlock' } | { __typename?: 'StructBlock' } | { __typename?: 'SubMenuBlock' } | { __typename?: 'TextBlock' } | { __typename?: 'TimeBlock' } | { __typename?: 'URLBlock' } | null> | null } | { __typename?: 'TextBlock', id?: string | null, blockType: string } | { __typename?: 'TimeBlock', id?: string | null, blockType: string } | { __typename?: 'URLBlock', id?: string | null, blockType: string } | null> | null } | null };

export type InternalFragment = { __typename?: 'InternalLinkBlock', href: string, text: string };

export type ExternalFragment = { __typename?: 'ExternalLinkBlock', href: string, text: string };

export const ImageRenditionFieldsFragmentDoc = gql`
    fragment imageRenditionFields on ImageRenditionObjectType {
  url
  width
  height
  image {
    title
  }
}
    `;
export const TeamPageFragmentDoc = gql`
    fragment teamPage on TeamPage {
  people {
    id
    name
    title
    linkedin
    location {
      name
      slug
    }
    image {
      rendition(fill: "410x410") {
        ...imageRenditionFields
      }
    }
  }
}
    ${ImageRenditionFieldsFragmentDoc}`;
export const RichTextFragmentDoc = gql`
    fragment richText on RichTextBlock {
  id
  value
}
    `;
export const FeaturedContentFragmentDoc = gql`
    fragment featuredContent on FeaturedContentBlock {
  title
  content
  image {
    rendition(fill: "1400x840") {
      ...imageRenditionFields
    }
  }
  link
  linkText
}
    ${ImageRenditionFieldsFragmentDoc}`;
export const VideoFragmentDoc = gql`
    fragment video on EmbedBlock {
  embed
}
    `;
export const QuoteBlockFragmentDoc = gql`
    fragment quoteBlock on QuoteBlock {
  field
  blocks {
    blockType
    field
    rawValue
  }
}
    `;
export const CaptionedImageFragmentDoc = gql`
    fragment captionedImage on CaptionedImageBlock {
  caption
  image {
    rendition(fill: "1400x840") {
      ...imageRenditionFields
    }
  }
}
    ${ImageRenditionFieldsFragmentDoc}`;
export const ListItemFragmentDoc = gql`
    fragment listItem on ListItem {
  indentationLevel
  text
}
    `;
export const DoubleListBlockFragmentDoc = gql`
    fragment doubleListBlock on DoubleListBlock {
  heading
  columnOne {
    ...listItem
  }
  columnTwo {
    ...listItem
  }
}
    ${ListItemFragmentDoc}`;
export const ProjectPageFragmentDoc = gql`
    fragment projectPage on ProjectPage {
  subtitle
  heroImage {
    rendition(fill: "1400x840") {
      ...imageRenditionFields
    }
  }
  heroCaption
  body {
    blockType
    ...richText
    ...featuredContent
    ...video
    ...quoteBlock
    ...captionedImage
    ...doubleListBlock
  }
  description
}
    ${ImageRenditionFieldsFragmentDoc}
${RichTextFragmentDoc}
${FeaturedContentFragmentDoc}
${VideoFragmentDoc}
${QuoteBlockFragmentDoc}
${CaptionedImageFragmentDoc}
${DoubleListBlockFragmentDoc}`;
export const ContentPageFragmentDoc = gql`
    fragment contentPage on ContentPage {
  subtitle
  heroImage {
    rendition(fill: "1400x840") {
      ...imageRenditionFields
    }
  }
  heroCaption
  body {
    blockType
    ...richText
    ...featuredContent
    ...video
    ...quoteBlock
    ...captionedImage
    ...doubleListBlock
  }
}
    ${ImageRenditionFieldsFragmentDoc}
${RichTextFragmentDoc}
${FeaturedContentFragmentDoc}
${VideoFragmentDoc}
${QuoteBlockFragmentDoc}
${CaptionedImageFragmentDoc}
${DoubleListBlockFragmentDoc}`;
export const NewsIndexFragmentDoc = gql`
    fragment newsIndex on NewsIndex {
  title
  tags {
    name
    slug
    isTagged
  }
}
    `;
export const NewsPageFragmentDoc = gql`
    fragment newsPage on NewsPage {
  subtitle
  heroImage {
    rendition(fill: "1400x840") {
      ...imageRenditionFields
    }
  }
  heroCaption
  body {
    blockType
    ...richText
    ...featuredContent
    ...video
    ...quoteBlock
    ...captionedImage
    ...doubleListBlock
  }
  tags {
    name
    slug
  }
}
    ${ImageRenditionFieldsFragmentDoc}
${RichTextFragmentDoc}
${FeaturedContentFragmentDoc}
${VideoFragmentDoc}
${QuoteBlockFragmentDoc}
${CaptionedImageFragmentDoc}
${DoubleListBlockFragmentDoc}`;
export const InternalFragmentDoc = gql`
    fragment Internal on InternalLinkBlock {
  href
  text
}
    `;
export const ExternalFragmentDoc = gql`
    fragment External on ExternalLinkBlock {
  href
  text
}
    `;
export const PageDocument = gql`
    query page($urlPath: String!, $token: String, $contentType: String) {
  page(urlPath: $urlPath, token: $token, contentType: $contentType) {
    title
    slug
    urlPath
    pageType
    seoTitle
    searchDescription
    ... on NewsIndex {
      ...newsIndex
      searchImage {
        rendition(fill: "1200x627") {
          ...imageRenditionFields
        }
      }
    }
    ... on NewsPage {
      ...newsPage
      searchImage {
        rendition(fill: "1200x627") {
          ...imageRenditionFields
        }
      }
    }
    ... on ContentPage {
      ...contentPage
      searchImage {
        rendition(fill: "1200x627") {
          ...imageRenditionFields
        }
      }
    }
    ... on ProjectPage {
      ...projectPage
      searchImage {
        rendition(fill: "1200x627") {
          ...imageRenditionFields
        }
      }
    }
    ... on TeamPage {
      ...teamPage
      searchImage {
        rendition(fill: "1200x627") {
          ...imageRenditionFields
        }
      }
    }
  }
  sites {
    siteName
    hostname
  }
  analyticsSettings {
    script
  }
}
    ${NewsIndexFragmentDoc}
${ImageRenditionFieldsFragmentDoc}
${NewsPageFragmentDoc}
${ContentPageFragmentDoc}
${ProjectPageFragmentDoc}
${TeamPageFragmentDoc}`;

/**
 * __usePageQuery__
 *
 * To run a query within a React component, call `usePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageQuery({
 *   variables: {
 *      urlPath: // value for 'urlPath'
 *      token: // value for 'token'
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function usePageQuery(baseOptions: Apollo.QueryHookOptions<PageQuery, PageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageQuery, PageQueryVariables>(PageDocument, options);
      }
export function usePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageQuery, PageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageQuery, PageQueryVariables>(PageDocument, options);
        }
export type PageQueryHookResult = ReturnType<typeof usePageQuery>;
export type PageLazyQueryHookResult = ReturnType<typeof usePageLazyQuery>;
export type PageQueryResult = Apollo.QueryResult<PageQuery, PageQueryVariables>;
export const GetNewsListingDocument = gql`
    query getNewsListing($page: PositiveInt, $perPage: PositiveInt, $tags: String) {
  newsPages(page: $page, perPage: $perPage, tags: $tags, order: "path") {
    items {
      id
      title
      urlPath
      tags {
        name
        slug
      }
      heroImage {
        rendition(fill: "397x397") {
          ...imageRenditionFields
        }
      }
    }
    pagination {
      total
    }
  }
}
    ${ImageRenditionFieldsFragmentDoc}`;

/**
 * __useGetNewsListingQuery__
 *
 * To run a query within a React component, call `useGetNewsListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsListingQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useGetNewsListingQuery(baseOptions?: Apollo.QueryHookOptions<GetNewsListingQuery, GetNewsListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsListingQuery, GetNewsListingQueryVariables>(GetNewsListingDocument, options);
      }
export function useGetNewsListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsListingQuery, GetNewsListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsListingQuery, GetNewsListingQueryVariables>(GetNewsListingDocument, options);
        }
export type GetNewsListingQueryHookResult = ReturnType<typeof useGetNewsListingQuery>;
export type GetNewsListingLazyQueryHookResult = ReturnType<typeof useGetNewsListingLazyQuery>;
export type GetNewsListingQueryResult = Apollo.QueryResult<GetNewsListingQuery, GetNewsListingQueryVariables>;
export const GetProjectListingDocument = gql`
    query getProjectListing($page: PositiveInt, $perPage: PositiveInt) {
  projectPages(page: $page, perPage: $perPage) {
    pagination {
      total
    }
    items {
      title
      description
      urlPath
      heroImage {
        rendition(fill: "1400x840") {
          ...imageRenditionFields
        }
      }
    }
  }
}
    ${ImageRenditionFieldsFragmentDoc}`;

/**
 * __useGetProjectListingQuery__
 *
 * To run a query within a React component, call `useGetProjectListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectListingQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetProjectListingQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectListingQuery, GetProjectListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectListingQuery, GetProjectListingQueryVariables>(GetProjectListingDocument, options);
      }
export function useGetProjectListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectListingQuery, GetProjectListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectListingQuery, GetProjectListingQueryVariables>(GetProjectListingDocument, options);
        }
export type GetProjectListingQueryHookResult = ReturnType<typeof useGetProjectListingQuery>;
export type GetProjectListingLazyQueryHookResult = ReturnType<typeof useGetProjectListingLazyQuery>;
export type GetProjectListingQueryResult = Apollo.QueryResult<GetProjectListingQuery, GetProjectListingQueryVariables>;
export const AllPagesDocument = gql`
    query allPages {
  pages {
    slug
    title
    id
    live
    urlPath
    pageType
  }
}
    `;

/**
 * __useAllPagesQuery__
 *
 * To run a query within a React component, call `useAllPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllPagesQuery(baseOptions?: Apollo.QueryHookOptions<AllPagesQuery, AllPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPagesQuery, AllPagesQueryVariables>(AllPagesDocument, options);
      }
export function useAllPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPagesQuery, AllPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPagesQuery, AllPagesQueryVariables>(AllPagesDocument, options);
        }
export type AllPagesQueryHookResult = ReturnType<typeof useAllPagesQuery>;
export type AllPagesLazyQueryHookResult = ReturnType<typeof useAllPagesLazyQuery>;
export type AllPagesQueryResult = Apollo.QueryResult<AllPagesQuery, AllPagesQueryVariables>;
export const HomePageDocument = gql`
    query HomePage($token: String) {
  home(token: $token) {
    path
    title
    slug
    seoTitle
    searchDescription
    searchImage {
      rendition(fill: "1200x627") {
        ...imageRenditionFields
      }
    }
    ctaLink {
      title
      url
    }
    ctaText
    explainer
    introText
    tagline
    heroImage {
      rendition(fill: "1400x840") {
        ...imageRenditionFields
      }
    }
    subrands {
      name
      description
      image {
        rendition(fill: "1050x810") {
          ...imageRenditionFields
        }
      }
      link {
        title
        urlPath
      }
      products {
        name
        page {
          urlPath
          title
        }
      }
    }
    projectListing {
      title
      url
    }
    featuredProjects {
      project {
        ... on ProjectPage {
          title
          urlPath
          heroImage {
            rendition(fill: "800x800") {
              ...imageRenditionFields
            }
          }
        }
      }
    }
    newsListing {
      title
      url
    }
    featuredNews {
      news {
        ... on NewsPage {
          title
          urlPath
          tags {
            name
            slug
          }
          heroImage {
            rendition(fill: "400x400") {
              ...imageRenditionFields
            }
          }
        }
      }
    }
  }
  sites {
    siteName
    hostname
  }
  analyticsSettings {
    script
  }
}
    ${ImageRenditionFieldsFragmentDoc}`;

/**
 * __useHomePageQuery__
 *
 * To run a query within a React component, call `useHomePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePageQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useHomePageQuery(baseOptions?: Apollo.QueryHookOptions<HomePageQuery, HomePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomePageQuery, HomePageQueryVariables>(HomePageDocument, options);
      }
export function useHomePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomePageQuery, HomePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomePageQuery, HomePageQueryVariables>(HomePageDocument, options);
        }
export type HomePageQueryHookResult = ReturnType<typeof useHomePageQuery>;
export type HomePageLazyQueryHookResult = ReturnType<typeof useHomePageLazyQuery>;
export type HomePageQueryResult = Apollo.QueryResult<HomePageQuery, HomePageQueryVariables>;
export const GetHeaderDocument = gql`
    query getHeader {
  menuSettings {
    subrandLinks {
      id
      blockType
      ...Internal
    }
  }
}
    ${InternalFragmentDoc}`;

/**
 * __useGetHeaderQuery__
 *
 * To run a query within a React component, call `useGetHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeaderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHeaderQuery(baseOptions?: Apollo.QueryHookOptions<GetHeaderQuery, GetHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHeaderQuery, GetHeaderQueryVariables>(GetHeaderDocument, options);
      }
export function useGetHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHeaderQuery, GetHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHeaderQuery, GetHeaderQueryVariables>(GetHeaderDocument, options);
        }
export type GetHeaderQueryHookResult = ReturnType<typeof useGetHeaderQuery>;
export type GetHeaderLazyQueryHookResult = ReturnType<typeof useGetHeaderLazyQuery>;
export type GetHeaderQueryResult = Apollo.QueryResult<GetHeaderQuery, GetHeaderQueryVariables>;
export const GetFooterDocument = gql`
    query getFooter {
  footerSettings {
    ctaText
    ctaEmail
    links {
      id
      blockType
      ...Internal
      ...External
    }
  }
}
    ${InternalFragmentDoc}
${ExternalFragmentDoc}`;

/**
 * __useGetFooterQuery__
 *
 * To run a query within a React component, call `useGetFooterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFooterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFooterQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFooterQuery(baseOptions?: Apollo.QueryHookOptions<GetFooterQuery, GetFooterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFooterQuery, GetFooterQueryVariables>(GetFooterDocument, options);
      }
export function useGetFooterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFooterQuery, GetFooterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFooterQuery, GetFooterQueryVariables>(GetFooterDocument, options);
        }
export type GetFooterQueryHookResult = ReturnType<typeof useGetFooterQuery>;
export type GetFooterLazyQueryHookResult = ReturnType<typeof useGetFooterLazyQuery>;
export type GetFooterQueryResult = Apollo.QueryResult<GetFooterQuery, GetFooterQueryVariables>;
export const GetMenuDocument = gql`
    query getMenu {
  menuSettings {
    menu {
      id
      blockType
      ...Internal
      ...External
      ... on SubMenuBlock {
        text
        href
        items {
          ...Internal
          ...External
        }
      }
    }
  }
}
    ${InternalFragmentDoc}
${ExternalFragmentDoc}`;

/**
 * __useGetMenuQuery__
 *
 * To run a query within a React component, call `useGetMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMenuQuery(baseOptions?: Apollo.QueryHookOptions<GetMenuQuery, GetMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuQuery, GetMenuQueryVariables>(GetMenuDocument, options);
      }
export function useGetMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuQuery, GetMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuQuery, GetMenuQueryVariables>(GetMenuDocument, options);
        }
export type GetMenuQueryHookResult = ReturnType<typeof useGetMenuQuery>;
export type GetMenuLazyQueryHookResult = ReturnType<typeof useGetMenuLazyQuery>;
export type GetMenuQueryResult = Apollo.QueryResult<GetMenuQuery, GetMenuQueryVariables>;
